import React from 'react';
import locationIcon from 'assets/location.png';
import { StyledCancelIcon } from './styledIcons';

export const AddIcon = () => (
  <svg viewBox="0 0 512 512">
    <g>
      <g>
        <path
          d="M492,236H276V20c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20v216H20c-11.046,0-20,8.954-20,20s8.954,20,20,20h216
          v216c0,11.046,8.954,20,20,20s20-8.954,20-20V276h216c11.046,0,20-8.954,20-20C512,244.954,503.046,236,492,236z"
        />
      </g>
    </g>
  </svg>
);

export const ViewIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26.666"
    height="20"
    viewBox="0 0 26.666 20"
  >
    <g data-name="visibility">
      <path
        d="M13.333 68.887A14.16 14.16 0 0 0 .045 78.618a.836.836 0 0 0 0 .539 14.16 14.16 0 0 0 13.289 9.731 14.16 14.16 0 0 0 13.289-9.731.836.836 0 0 0 0-.539 14.16 14.16 0 0 0-13.289-9.731zm0 18.333a12.482 12.482 0 0 1-11.616-8.333 12.482 12.482 0 0 1 11.616-8.333 12.482 12.482 0 0 1 11.616 8.333 12.482 12.482 0 0 1-11.616 8.333z"
        data-name="Path 77437"
        transform="translate(0 -68.887)"
      />
      <path
        d="M13.333 73.887a5 5 0 1 0 5 5 5.005 5.005 0 0 0-5-5zm0 8.333a3.333 3.333 0 1 1 3.333-3.333 3.337 3.337 0 0 1-3.333 3.333z"
        data-name="Path 77438"
        transform="translate(0 -68.887)"
      />
    </g>
  </svg>
);

export const SignOutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.538"
    height="20"
    viewBox="0 0 18.538 20"
  >
    <g
      id="prefix__logout_8_"
      data-name="logout (8)"
      transform="translate(-17.219)"
    >
      <g
        id="prefix__Group_1974"
        data-name="Group 1974"
        transform="translate(17.219)"
      >
        <path
          id="prefix__Path_77159"
          d="M26.149 18.854h-5.216a2.571 2.571 0 0 1-2.568-2.568V3.714a2.571 2.571 0 0 1 2.568-2.568h5.3a.573.573 0 0 0 0-1.146h-5.3a3.718 3.718 0 0 0-3.714 3.714v12.572A3.718 3.718 0 0 0 20.933 20h5.216a.573.573 0 1 0 0-1.146z"
          className="prefix__cls-1"
          data-name="Path 77159"
          transform="translate(-17.219)"
        />
        <path
          id="prefix__Path_77160"
          d="M134.5 140.135l-3.642-3.642a.573.573 0 0 0-.811.811l2.666 2.666h-11.621a.573.573 0 0 0 0 1.146h11.626l-2.666 2.666a.575.575 0 0 0 .4.98.559.559 0 0 0 .4-.17l3.642-3.642a.573.573 0 0 0 .006-.815z"
          className="prefix__cls-1"
          data-name="Path 77160"
          transform="translate(-116.134 -130.539)"
        />
      </g>
    </g>
  </svg>
);

export const LastLoginIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__enter"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path
      id="prefix__Path_77516"
      d="M8.542 209.25H.625a.625.625 0 0 1 0-1.25h7.917a.625.625 0 0 1 0 1.25zm0 0"
      className="prefix__cls-1"
      data-name="Path 77516"
      transform="translate(0 -199.875)"
    />
    <path
      id="prefix__Path_77517"
      d="M123.3 135.485a.625.625 0 0 1-.442-1.068l2.683-2.683-2.683-2.682a.625.625 0 1 1 .884-.884l3.125 3.125a.625.625 0 0 1 0 .884l-3.125 3.125a.624.624 0 0 1-.442.183zm0 0"
      className="prefix__cls-1"
      data-name="Path 77517"
      transform="translate(-117.88 -122.985)"
    />
    <path
      id="prefix__Path_77518"
      d="M300.335 20.08a1.668 1.668 0 0 1-1.667-1.667v-15A1.677 1.677 0 0 1 299.8 1.83l5-1.669a1.684 1.684 0 0 1 2.2 1.585v15a1.678 1.678 0 0 1-1.127 1.582L300.865 20a1.744 1.744 0 0 1-.53.08zm5-18.75a.49.49 0 0 0-.149.022L300.2 3.014a.43.43 0 0 0-.282.4v15a.439.439 0 0 0 .566.4l4.986-1.662a.431.431 0 0 0 .282-.4v-15a.417.417 0 0 0-.417-.422zm0 0"
      className="prefix__cls-1"
      data-name="Path 77518"
      transform="translate(-287.001 -.08)"
    />
    <path
      id="prefix__Path_77519"
      d="M171.293 4.167a.625.625 0 0 1-.625-.625v-1.25A2.293 2.293 0 0 1 172.96 0h9.375a.625.625 0 0 1 0 1.25h-9.375a1.043 1.043 0 0 0-1.042 1.042v1.25a.625.625 0 0 1-.625.625zm0 0"
      className="prefix__cls-1"
      data-name="Path 77519"
      transform="translate(-164.001)"
    />
    <path
      id="prefix__Path_77520"
      d="M176.293 345.5h-3.333a2.293 2.293 0 0 1-2.292-2.292v-1.25a.625.625 0 0 1 1.25 0v1.25a1.043 1.043 0 0 0 1.042 1.042h3.333a.625.625 0 0 1 0 1.25zm0 0"
      className="prefix__cls-1"
      data-name="Path 77520"
      transform="translate(-164.001 -327.999)"
    />
  </svg>
);

export const QuestionMarkIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.2"
    height="20.2"
    viewBox="0 0 20.2 20.2"
  >
    <g id="prefix__round" transform="translate(.1 .1)">
      <path
        id="prefix__Path_77340"
        d="M236.335 363.5a.833.833 0 1 1-.833-.833.833.833 0 0 1 .833.833zm0 0"
        className="prefix__cls-1"
        data-name="Path 77340"
        transform="translate(-225.501 -348.501)"
      />
      <path
        id="prefix__Path_77341"
        d="M10 20a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-18.75A8.75 8.75 0 1 0 18.75 10 8.76 8.76 0 0 0 10 1.25zm0 0"
        className="prefix__cls-1"
        data-name="Path 77341"
      />
      <path
        id="prefix__Path_77342"
        d="M168.874 94.29a.625.625 0 0 1-.625-.625v-.842a1.879 1.879 0 0 1 1.252-1.768 2.586 2.586 0 0 0 1.665-2.182 2.292 2.292 0 0 0-4.583 0 .625.625 0 0 1-1.25 0 3.542 3.542 0 0 1 7.083 0 3.835 3.835 0 0 1-2.5 3.361.625.625 0 0 0-.417.59v.841a.625.625 0 0 1-.625.625zm0 0"
        className="prefix__cls-1"
        data-name="Path 77342"
        transform="translate(-158.874 -81.999)"
      />
    </g>
  </svg>
);

export const AddCircleIcon = () => (
  <svg
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__plus_4_"
    width="30"
    height="30"
    data-name="plus (4)"
    viewBox="0 0 30 30"
  >
    <path
      id="prefix__Path_77157"
      d="M15 0a15 15 0 1 0 15 15A15.017 15.017 0 0 0 15 0zm0 28.846A13.846 13.846 0 1 1 28.846 15 13.862 13.862 0 0 1 15 28.846z"
      className="prefix__cls-1"
      data-name="Path 77157"
    />
    <path
      id="prefix__Path_77158"
      d="M27.5 19.923h-6.635v-6.346a.577.577 0 1 0-1.154 0v6.346h-6.634a.577.577 0 1 0 0 1.154h6.635V28a.577.577 0 1 0 1.154 0v-6.923H27.5a.577.577 0 0 0 0-1.154z"
      className="prefix__cls-1"
      data-name="Path 77158"
      transform="translate(-5.288 -5.5)"
    />
  </svg>
);

export const AddJobIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23.171"
    height="20.3"
    viewBox="0 0 23.171 20.3"
  >
    <g id="follow" transform="translate(.15 -2.62)">
      <g
        id="Group_2633"
        data-name="Group 2633"
        transform="translate(14.354 3.008)"
      >
        <g id="Group_2632" data-name="Group 2632">
          <path
            id="Path_77499"
            d="M329.181 3.588h-2.918V.67a.67.67 0 0 0-1.34 0v2.918H322a.67.67 0 0 0 0 1.34h2.918v2.919a.67.67 0 0 0 1.34 0V4.929h2.918a.67.67 0 0 0 0-1.34z"
            className="cls-1"
            data-name="Path 77499"
            transform="translate(-321.334)"
          />
        </g>
      </g>
      <g id="Group_2635" data-name="Group 2635" transform="translate(0 14.253)">
        <g id="Group_2634" data-name="Group 2634">
          <path
            id="Path_77500"
            d="M7.847 321.334A7.856 7.856 0 0 0 0 329.181a.67.67 0 0 0 .67.67h14.354a.67.67 0 0 0 .67-.67 7.856 7.856 0 0 0-7.847-7.847zm-6.473 7.177a6.507 6.507 0 0 1 12.945 0z"
            className="cls-1"
            data-name="Path 77500"
            transform="translate(0 -321.334)"
          />
        </g>
      </g>
      <g
        id="Group_2637"
        data-name="Group 2637"
        transform="translate(3.588 2.77)"
      >
        <g id="Group_2636" data-name="Group 2636">
          <path
            id="Path_77501"
            d="M84.592 64.267a4.259 4.259 0 1 0 4.259 4.259 4.263 4.263 0 0 0-4.259-4.259zm0 7.177a2.918 2.918 0 1 1 2.918-2.918 2.922 2.922 0 0 1-2.918 2.918z"
            className="cls-1"
            data-name="Path 77501"
            transform="translate(-80.334 -64.267)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const AddLocationIcon = () => (
  <img alt="add-location-icon" src={locationIcon} className="icon" />
);

export const DeleteIcon = () => (
  <svg viewBox="0 0 24 24">
    <g stroke="" strokeWidth=".4">
      <path d="M20,3.92H15.9V3.18A1.78,1.78,0,0,0,14.12,1.4H9.92A1.78,1.78,0,0,0,8.14,3.18v.74H4a.1.1,0,0,0-.1.1v.84A.1.1,0,0,0,4,5h.74l.77,15.55a2.2,2.2,0,0,0,2.2,2.09h8.53a2.2,2.2,0,0,0,2.2-2.09L19.26,5H20a.1.1,0,0,0,.1-.1V4A.1.1,0,0,0,20,3.92ZM9.92,2.44h4.2a.74.74,0,0,1,.74.74v.74H9.18V3.18A.74.74,0,0,1,9.92,2.44Zm8.35,2.42h0Zm-2,16.7H7.76a1.16,1.16,0,0,1-1.16-1.1L5.82,5H18.21l-.77,15.5A1.16,1.16,0,0,1,16.28,21.56Z" />
      <rect x="11.5" y="6.44" width="1.04" height="13.64" rx="0.1" ry="0.1" />
      <path d="M15.8,6.44H15a.1.1,0,0,0-.1.09L14,20A.1.1,0,0,0,14,20a.1.1,0,0,0,.07,0H15a.1.1,0,0,0,.1-.09L15.9,6.56a.08.08,0,0,0,0,0A.1.1,0,0,0,15.8,6.44Zm0,.1h0l0,.74Zm-1.63,12.7,0,.74h0Z" />
      <path d="M9.08,6.44H8.24a.1.1,0,0,0-.07,0,.1.1,0,0,0,0,.07L9,20a.1.1,0,0,0,.1.09h.84A.1.1,0,0,0,10,20,.1.1,0,0,0,10,20L9.18,6.53A.1.1,0,0,0,9.08,6.44Z" />
    </g>
  </svg>
);

export const ClockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path
      id="prefix__clock_7_"
      d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0zm4.756 15.172a.833.833 0 0 1-1.178 0l-4.167-4.166a.83.83 0 0 1-.244-.589V5a.833.833 0 1 1 1.667 0v5.072l3.923 3.922a.832.832 0 0 1-.001 1.178zm0 0"
      data-name="clock"
    />
  </svg>
);

export const PlusWithCircleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__plus_3_"
    width="44"
    height="44"
    data-name="plus (3)"
    viewBox="0 0 44 44"
  >
    <path
      id="prefix__Path_77153"
      d="M22 0a22 22 0 1 0 22 22A22.025 22.025 0 0 0 22 0zm0 42.308A20.308 20.308 0 1 1 42.308 22 20.331 20.331 0 0 1 22 42.308z"
      className="prefix__cls-1"
      data-name="Path 77153"
    />
    <path
      id="prefix__Path_77154"
      d="M34.5 23.154h-9.731v-9.308a.846.846 0 0 0-1.692 0v9.308h-9.731a.846.846 0 0 0 0 1.692h9.731V35a.846.846 0 1 0 1.692 0V24.846H34.5a.846.846 0 1 0 0-1.692z"
      className="prefix__cls-1"
      data-name="Path 77154"
      transform="translate(-1.923 -2)"
    />
  </svg>
);

export const RestoreIcon = () => (
  <svg height="512pt" viewBox="0 0 512 512.00241" width="512pt">
    <path d="m256 .00390625c-62.675781 0-123.605469 23.08203175-171.09375 62.26953175l-57.597656-57.597657c-4.585938-4.566406-11.457032-5.933593-17.429688-3.457031-5.972656 2.472656-9.878906 8.296875-9.878906 14.785156v138.664063c0 8.832031 7.167969 16 16 16h138.667969c6.484375 0 12.308593-3.902344 14.785156-9.875 2.472656-5.972657 1.109375-12.84375-3.480469-17.429688l-50.75-50.773437c39.445313-31.425782 89.363282-49.921875 140.777344-49.921875 117.632812 0 213.335938 95.703125 213.335938 213.335937 0 117.628906-95.703126 213.332032-213.335938 213.332032-56.9375 0-110.503906-22.207032-150.804688-62.527344-8.339843-8.34375-21.824218-8.34375-30.164062 0-8.34375 8.339844-8.34375 21.824218 0 30.164062 48.363281 48.382813 112.640625 75.03125 180.96875 75.03125 141.164062 0 256-114.839844 256-256 0-141.164062-114.835938-255.99999975-256-255.99999975zm0 0" />
  </svg>
);

export const ContractIcon = () => (
  <svg
    id="Capa_1"
    enable-background="new 0 0 512 512"
    height="512"
    viewBox="0 0 512 512"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g>
        <path d="m334.954 137.804h-245.189c-4.16 0-7.532 3.372-7.532 7.532s3.372 7.532 7.532 7.532h245.19c4.16 0 7.532-3.372 7.532-7.532s-3.373-7.532-7.533-7.532z" />
        <path d="m89.765 100.621h122.594c4.16 0 7.532-3.372 7.532-7.532s-3.372-7.532-7.532-7.532h-122.594c-4.16 0-7.532 3.372-7.532 7.532 0 4.161 3.372 7.532 7.532 7.532z" />
        <path d="m334.954 184.096h-245.189c-4.16 0-7.532 3.372-7.532 7.532s3.372 7.532 7.532 7.532h245.19c4.16 0 7.532-3.372 7.532-7.532-.001-4.16-3.373-7.532-7.533-7.532z" />
        <path d="m145.618 459.668h-78.467c-12.879 0-23.358-10.478-23.358-23.357v-397.89c0-12.879 10.479-23.358 23.358-23.358h226.056c.73 0 1.449.067 2.16.163v46.974c0 21.186 17.236 38.421 38.421 38.421h46.973c.097.712.163 1.431.163 2.161v128.261c0 4.16 3.372 7.532 7.532 7.532s7.532-3.372 7.532-7.532v-128.26c0-8.262-3.218-16.03-9.06-21.873l-71.85-71.85c-5.842-5.842-13.609-9.06-21.871-9.06h-226.056c-21.186 0-38.421 17.236-38.421 38.421v397.89c0 21.185 17.236 38.42 38.421 38.42h78.467c4.16 0 7.532-3.372 7.532-7.532s-3.372-7.531-7.532-7.531zm224.655-374.11h-36.484c-12.879 0-23.358-10.479-23.358-23.358v-36.484z" />
        <path d="m480.958 368.729-63.818-107.72c-4.651-7.854-14.773-10.45-22.631-5.795l-15.523 9.197c-12.049 7.138-17.142 21.583-13.005 34.384-5.23 1.895-10.964 1.865-16.244-.176-12.256-3.856-21.574-11.613-36.963-7.721-26.13 6.653-25.336 6.32-27.7 7.13-15.3-8.711-24.497-11.303-40.739-5.02l-14.478 5.597c-6.703 2.59-14.089 1.976-20.283-1.694l-3.951-2.329c1.928-11.552-3.195-23.743-14.043-30.169 0 0 0 0-.001-.001l-15.522-9.196c-7.836-4.641-17.988-2.043-22.63 5.793l-63.82 107.721c-4.651 7.852-2.063 17.977 5.793 22.63l15.522 9.196c4.697 2.783 9.859 4.106 14.959 4.106 5.687 0 11.294-1.648 16.088-4.752l3.235 1.909-6.83 9.513c-8.139 11.338-5.553 27.104 5.787 35.244 5.244 3.764 11.832 5.483 18.645 4.413 1.081 6.319 4.543 12.233 10.149 16.259 5.265 3.78 11.823 5.501 18.648 4.426 1.084 6.314 4.544 12.223 10.147 16.246 7.53 5.405 16.892 6.03 24.693 2.698 1.707 4.434 4.674 8.438 8.813 11.41 10.808 7.757 25.696 5.734 34.094-4.316l18.15 10.752c12.003 7.113 27.49 3.16 34.607-8.857 1.82-3.072 2.949-6.42 3.362-9.861l.041.025c11.985 7.098 27.507 3.124 34.607-8.858 2.056-3.471 3.183-7.236 3.457-11.009 10.564 2.656 22.077-1.781 27.907-11.621 1.913-3.228 3.022-6.715 3.387-10.224 11.322 4.443 24.555.149 30.949-10.643 3.439-5.805 4.412-12.601 2.739-19.138-.957-3.74-2.717-7.135-5.133-10.002l10.004-5.845c8.463 3.474 18.121 2.918 26.215-1.876l15.52-9.196c7.856-4.65 10.451-14.773 5.796-22.63zm-362.358 18.868-15.522-9.197c-.69-.409-.919-1.303-.511-1.993l63.82-107.723c.411-.693 1.308-.918 1.994-.51l15.521 9.195c6.897 4.087 9.055 12.933 5.043 19.704l-50.641 85.48c-4.042 6.824-12.88 9.085-19.704 5.044zm34.345 46.742c-4.574-3.284-5.62-9.646-2.334-14.222l10.039-13.984c3.198-4.455 9.571-5.674 14.222-2.335 4.565 3.277 5.612 9.656 2.336 14.221l-10.04 13.984c-3.277 4.567-9.66 5.611-14.223 2.336zm28.795 20.673c-4.565-3.278-5.612-9.659-2.335-14.223l10.039-13.983s0 0 0-.001c0 0 0-.001.001-.001l11.079-15.432c1.588-2.211 3.941-3.673 6.627-4.113.558-.092 1.117-.137 1.672-.137 2.114 0 4.171.658 5.923 1.915 2.21 1.588 3.672 3.94 4.112 6.626.441 2.687-.19 5.384-1.778 7.595l-21.119 29.418c-3.282 4.575-9.645 5.622-14.221 2.336zm28.795 20.671c-4.563-3.276-5.611-9.652-2.34-14.216.001-.002.003-.004.004-.006l21.119-29.417c3.275-4.564 9.659-5.612 14.222-2.336 4.565 3.277 5.612 9.657 2.335 14.222l-9.383 13.071s0 0-.001.001l-11.735 16.346c-3.277 4.565-9.655 5.614-14.221 2.335zm33.506 14.108c-4.562-3.276-5.611-9.649-2.342-14.214l7.029-9.79c3.276-4.566 9.659-5.61 14.222-2.335 4.564 3.276 5.612 9.657 2.335 14.222l-7.023 9.781c-3.276 4.566-9.658 5.614-14.221 2.336zm168.819-60.052c-2.866 4.837-9.13 6.441-13.968 3.576-8.192-4.853-61.036-36.16-66.67-39.498-3.58-2.12-8.199-.939-10.319 2.64s-.939 8.199 2.64 10.319l50.403 29.861.001.001c4.839 2.866 6.453 9.111 3.576 13.969-2.867 4.839-9.134 6.44-13.97 3.577-18.642-11.044-33.779-20.012-50.43-29.877-3.581-2.12-8.199-.939-10.319 2.64s-.939 8.199 2.64 10.319l37.138 22.002.008.005c4.842 2.875 6.44 9.117 3.569 13.965-2.867 4.839-9.132 6.442-13.971 3.576l-19.931-11.807c-.002-.001-.005-.002-.007-.004-.002-.001-.004-.002-.006-.003l-14.545-8.618c-3.58-2.121-8.199-.94-10.319 2.64-2.12 3.579-.939 8.199 2.64 10.319l14.548 8.619c.002.001.004.003.006.004 4.839 2.866 6.453 9.11 3.576 13.968-2.867 4.839-9.132 6.442-13.971 3.576l-16.971-10.053c7.275-11.226 4.508-26.354-6.473-34.236-3.225-2.314-6.816-3.755-10.489-4.374 3.896-10.417.537-22.579-8.922-29.369-5.6-4.022-12.305-5.411-18.633-4.419-1.126-6.585-4.727-12.353-10.16-16.252-10.218-7.333-24.104-5.924-32.681 2.753-1.743-3.061-4.149-5.807-7.193-7.992-8.491-6.094-19.515-6.151-27.921-1.018l-3.451-2.037 47.37-79.959 2.255 1.33c9.96 5.9 22.114 7.13 33.378 2.774l14.478-5.597c8.285-3.202 12.854-3.411 21.049.456-5.362 6.024-8.545 13.933-8.545 22.457v33.395c0 8.87 7.211 16.091 16.074 16.097h.022c8.89 0 17.25-3.461 23.539-9.746 3.666-3.664 6.372-8.032 7.994-12.8 9.725 5.759 90.072 53.338 99.387 58.857 2.343 1.388 4.005 3.605 4.68 6.243.675 2.635.282 5.378-1.106 7.721zm54.628-51.339-15.523 9.197c-6.824 4.04-15.662 1.777-19.702-5.043l-23.736-40.065c-2.121-3.579-6.743-4.76-10.319-2.642-3.579 2.12-4.761 6.74-2.642 10.319l23.736 40.066c.447.754.932 1.471 1.434 2.17l-6.599 3.855c-1.334.79-2.617 1.66-3.844 2.605l-102.323-60.595c-5.013-2.967-11.369.65-11.369 6.48-.079.45.778 8.192-5.345 14.313-3.444 3.441-8.022 5.337-12.891 5.337-.004 0-.008 0-.012 0-.563 0-1.021-.464-1.021-1.034v-33.395c0-8.724 6.002-16.084 14.119-18.139l25.016-6.331c9.077-2.294 14.208 2.553 27.799 7.153 9.435 3.65 19.694 3.425 28.8-.464l4.546 7.674c2.121 3.581 6.741 4.761 10.319 2.642 3.579-2.12 4.761-6.74 2.642-10.319l-8.954-15.113c-4.051-6.838-1.794-15.65 5.043-19.703l15.522-9.195c.678-.403 1.575-.197 1.995.511l63.818 107.721c.412.695.185 1.584-.509 1.995z" />
      </g>
    </g>
  </svg>
);

export const EditIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.998"
    height="20"
    viewBox="0 0 19.998 20"
  >
    <path
      id="Path_77145"
      d="M126.491 1.159a3.068 3.068 0 0 0-4.339 0l-12.163 12.163a.682.682 0 0 0-.175.3l-1.6 5.774a.682.682 0 0 0 .839.839l5.774-1.6a.682.682 0 0 0 .3-.175L127.291 6.3a3.071 3.071 0 0 0 0-4.339zm-15.016 12.606l9.954-9.955 3.21 3.21-9.955 9.955zm-.641 1.287l2.565 2.565-3.548.983zm15.493-9.718l-.723.723-3.211-3.211.723-.723a1.7 1.7 0 0 1 2.41 0l.8.8a1.707 1.707 0 0 1 .001 2.411zm0 0"
      data-name="Path 77145"
      transform="translate(-108.19 -.261)"
    />
  </svg>
);

export const AssignIcon = () => (
  <svg width="20" height="20" viewBox="0 0 496 496.00305" xmlns="http://www.w3.org/2000/svg">
    <path d="m493.25 161.960938-184-160c-2.367188-2.054688-5.714844-2.539063-8.566406-1.238282-2.851563 1.296875-4.683594 4.144532-4.683594 7.277344v64.265625c-30.722656.957031-61.375 3.613281-91.804688 7.953125-41.753906 8.773438-80.871093 27.203125-114.21875 53.816406-56.210937 44.203125-89.308593 111.539063-89.976562 183.046875.609375 68.203125 30.808594 132.777344 82.761719 176.96875 2.503906 2.167969 6.085937 2.570313 9.007812 1.007813s4.578125-4.761719 4.167969-8.046875c-.992188-8.375-1.464844-16.800781-1.40625-25.234375-.222656-27.894532 5.746094-55.488282 17.46875-80.800782 20.109375-40.351562 52.234375-73.480468 91.953125-94.824218 28.292969-15.105469 59.980469-22.730469 92.046875-22.152344v64c0 3.136719 1.832031 5.984375 4.683594 7.28125 2.851562 1.300781 6.199218.816406 8.566406-1.238281l184-160c1.75-1.519531 2.753906-3.722657 2.753906-6.042969 0-2.316406-1.003906-4.519531-2.753906-6.039062zm-181.25 148.488281v-54.449219c0-4.386719-3.53125-7.953125-7.917969-8-43.382812-.261719-77.679687 7.273438-107.9375 24.179688-42.621093 22.988281-77.074219 58.621093-98.605469 102-12.730468 27.433593-19.222656 57.351562-19.007812 87.597656 0 2.183594.023438 4.316406.070312 6.402344-40.03125-40.101563-62.542968-94.433594-62.601562-151.097657.679688-66.664062 31.578125-129.417969 84-170.609375 31.402344-25.027344 68.222656-42.359375 107.523438-50.613281 32.058593-4.355469 64.328124-6.976563 96.671874-7.859375 4.339844-.101562 7.808594-3.652344 7.804688-8v-54.445312l163.808594 142.445312zm0 0" />
  </svg>
)

export const AssignMultIcon = () => (
  <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path id="left" d="M24,39.171a.828.828,0,0,0,1.655,0A10.206,10.206,0,0,1,35.77,28.965l1.1-.829-1.1-.827A11.852,11.852,0,0,0,24,39.171Zm10.1-7.228a.828.828,0,0,1,.166-1.159l3.531-2.648-3.531-2.648a.828.828,0,1,1,.993-1.324l4.414,3.31a.828.828,0,0,1,0,1.324l-4.414,3.31a.828.828,0,0,1-1.159-.166Z" transform="translate(-24 -23.999)" />
  </svg>
)

export const RescheduleIcon = () => (
  <svg
    fill="white"
    xmlns="http://www.w3.org/2000/svg"
    width="20.1"
    height="20.1"
    viewBox="0 0 20.1 20.1"
  >
    <g
      id="calendar_4_"
      data-name="calendar (4)"
      transform="translate(0.05 0.05)"
    >
      <g id="Group_2830" data-name="Group 2830">
        <g id="Group_2829" data-name="Group 2829">
          <circle
            id="Ellipse_691"
            data-name="Ellipse 691"
            cx="0.781"
            cy="0.781"
            r="0.781"
            transform="translate(14.297 7.422)"
            stroke="#fff"
            strokeWidth="0.1"
          />
          <path
            id="Path_77567"
            data-name="Path 77567"
            d="M16.875,1.563H15.859V.781a.781.781,0,0,0-1.562,0v.781H10.742V.781a.781.781,0,0,0-1.562,0v.781H5.664V.781A.781.781,0,0,0,4.1.781v.781H3.125A3.129,3.129,0,0,0,0,4.688V16.875A3.129,3.129,0,0,0,3.125,20H9.1a.781.781,0,0,0,0-1.562H3.125a1.564,1.564,0,0,1-1.562-1.562V4.688A1.564,1.564,0,0,1,3.125,3.125H4.1v.781a.781.781,0,0,0,1.563,0V3.125H9.18v.781a.781.781,0,0,0,1.563,0V3.125H14.3v.781a.781.781,0,0,0,1.563,0V3.125h1.016a1.564,1.564,0,0,1,1.563,1.563V9.141a.781.781,0,0,0,1.563,0V4.688A3.129,3.129,0,0,0,16.875,1.563Z"
            stroke="#fff"
            strokeWidth="0.1"
          />
          <path
            id="Path_77568"
            data-name="Path 77568"
            d="M274.727,270a4.727,4.727,0,1,0,4.727,4.727A4.732,4.732,0,0,0,274.727,270Zm0,7.891a3.164,3.164,0,1,1,3.164-3.164A3.168,3.168,0,0,1,274.727,277.891Z"
            transform="translate(-259.453 -259.453)"
            stroke="#fff"
            strokeWidth="0.1"
          />
          <path
            id="Path_77569"
            data-name="Path 77569"
            d="M372.914,331.6h-.352v-.82a.781.781,0,0,0-1.562,0v1.6a.781.781,0,0,0,.781.781h1.133a.781.781,0,0,0,0-1.562Z"
            transform="translate(-356.508 -317.109)"
            stroke="#fff"
            strokeWidth="0.1"
          />
          <circle
            id="Ellipse_692"
            data-name="Ellipse 692"
            cx="0.781"
            cy="0.781"
            r="0.781"
            transform="translate(10.898 7.422)"
            stroke="#fff"
            strokeWidth="0.1"
          />
          <circle
            id="Ellipse_693"
            data-name="Ellipse 693"
            cx="0.781"
            cy="0.781"
            r="0.781"
            transform="translate(7.5 10.82)"
            stroke="#fff"
            strokeWidth="0.1"
          />
          <circle
            id="Ellipse_694"
            data-name="Ellipse 694"
            cx="0.781"
            cy="0.781"
            r="0.781"
            transform="translate(4.102 7.422)"
            stroke="#fff"
            strokeWidth="0.1"
          />
          <circle
            id="Ellipse_695"
            data-name="Ellipse 695"
            cx="0.781"
            cy="0.781"
            r="0.781"
            transform="translate(4.102 10.82)"
            stroke="#fff"
            strokeWidth="0.1"
          />
          <circle
            id="Ellipse_696"
            data-name="Ellipse 696"
            cx="0.781"
            cy="0.781"
            r="0.781"
            transform="translate(4.102 14.219)"
            stroke="#fff"
            strokeWidth="0.1"
          />
          <circle
            id="Ellipse_697"
            data-name="Ellipse 697"
            cx="0.781"
            cy="0.781"
            r="0.781"
            transform="translate(7.5 14.219)"
            stroke="#fff"
            strokeWidth="0.1"
          />
          <circle
            id="Ellipse_698"
            data-name="Ellipse 698"
            cx="0.781"
            cy="0.781"
            r="0.781"
            transform="translate(7.5 7.422)"
            stroke="#fff"
            strokeWidth="0.1"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const LinkIcon = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 512.01 512.01"
  >
    <g>
      <g>
        <path
          d="M465.755,240.717l-42.488-42.496c-8.441-8.434-22.112-8.434-30.554,0c-8.442,8.441-8.442,22.127,0,30.561l42.488,42.496
          c44.887,44.894,44.844,118.469,0,163.918c-44.88,44.88-118.455,44.844-163.918,0l-42.496-42.488
          c-8.434-8.441-22.119-8.441-30.561,0c-8.442,8.442-8.442,22.119,0,30.554l42.596,42.596
          c31.166,30.748,71.947,46.133,112.642,46.133c40.781,0,81.491-15.45,112.397-46.342
          C527.432,403.238,527.388,302.343,465.755,240.717z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M313.772,88.749l-42.596-42.604c-62.396-61.561-163.298-61.511-225.032,0.209
          c-61.568,62.404-61.518,163.298,0.108,224.924l42.496,42.496c4.214,4.221,9.745,6.331,15.277,6.331
          c5.524,0,11.056-2.11,15.277-6.338c8.441-8.434,8.441-22.119,0-30.554l-42.496-42.496c-44.887-44.887-44.844-118.462,0-163.911
          c44.894-44.88,118.469-44.836,163.918,0l42.496,42.496c8.442,8.442,22.112,8.442,30.554,0
          C322.214,110.868,322.214,97.183,313.772,88.749z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M326.017,295.472l-109.48-109.48c-8.434-8.442-22.119-8.442-30.554,0c-8.441,8.434-8.441,22.119,0,30.554l109.48,109.48
          c4.221,4.221,9.745,6.331,15.277,6.331s11.056-2.11,15.277-6.331C334.458,317.591,334.458,303.906,326.017,295.472z"
        />
      </g>
    </g>
  </svg>
);

export const WarningIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21.878"
    height="20"
    viewBox="0 0 21.878 20"
  >
    <g
      id="prefix__warning_1_"
      data-name="warning (1)"
      transform="translate(0 -20.882)"
    >
      <g
        id="prefix__Group_1883"
        data-name="Group 1883"
        transform="translate(0 20.882)"
      >
        <path
          id="prefix__Path_74185"
          d="M219.349 333.382a1.124 1.124 0 0 0 0 2.249 1.125 1.125 0 0 0 0-2.249z"
          className="prefix__cls-1"
          data-name="Path 74185"
          transform="translate(-208.411 -319.328)"
        />
        <path
          id="prefix__Path_74186"
          d="M21.345 38.921a3.839 3.839 0 0 0 .009-3.886l-7.043-12.2a3.88 3.88 0 0 0-6.737 0L.522 35.044A3.9 3.9 0 0 0 3.9 40.882h14.063a3.873 3.873 0 0 0 3.382-1.961zm-1.529-.881a2.125 2.125 0 0 1-1.857 1.075H3.891a2.1 2.1 0 0 1-1.835-1.052 2.128 2.128 0 0 1 0-2.145L9.1 23.711a2.118 2.118 0 0 1 3.679 0l7.051 12.21a2.1 2.1 0 0 1-.014 2.119z"
          className="prefix__cls-1"
          data-name="Path 74186"
          transform="translate(0 -20.882)"
        />
        <path
          id="prefix__Path_74187"
          d="M218.593 157.208a1.223 1.223 0 0 0-.868 1.228c.027.355.049.715.076 1.07l.229 4.034a.824.824 0 0 0 .841.792.841.841 0 0 0 .841-.819c0-.279 0-.535.027-.819.049-.868.1-1.736.153-2.6.027-.562.076-1.124.1-1.687a1.389 1.389 0 0 0-.1-.562 1.127 1.127 0 0 0-1.299-.637z"
          className="prefix__cls-1"
          data-name="Path 74187"
          transform="translate(-207.933 -151.046)"
        />
      </g>
    </g>
  </svg>
);

export const PhotoIcon = () => (
  <svg
    fill="white"
    xmlns="http://www.w3.org/2000/svg"
    width="29.504"
    height="25"
    viewBox="0 0 29.504 25"
  >
    <path
      id="prefix__photo-camera"
      d="M24.894 43.617h-2.63l-.992-1.985a4.585 4.585 0 0 0-4.123-2.548h-4.793a4.585 4.585 0 0 0-4.123 2.548l-.993 1.985H4.61A4.615 4.615 0 0 0 0 48.227v11.247a4.615 4.615 0 0 0 4.61 4.61h20.284a4.615 4.615 0 0 0 4.61-4.61V48.227a4.615 4.615 0 0 0-4.61-4.61zM27.2 59.474a2.308 2.308 0 0 1-2.305 2.305H4.61a2.308 2.308 0 0 1-2.305-2.305V48.227a2.308 2.308 0 0 1 2.305-2.305h3.342a1.153 1.153 0 0 0 1.031-.637l1.311-2.622a2.292 2.292 0 0 1 2.062-1.274h4.793a2.292 2.292 0 0 1 2.062 1.274l1.311 2.622a1.152 1.152 0 0 0 1.031.637h3.342a2.308 2.308 0 0 1 2.305 2.305zM14.752 47a5.686 5.686 0 1 0 5.686 5.686A5.692 5.692 0 0 0 14.752 47zm0 9.066a3.381 3.381 0 1 1 3.381-3.381 3.385 3.385 0 0 1-3.381 3.379z"
      transform="translate(0 -39.084)"
    />
  </svg>
);

export const YourCodeIcon = () => (
  <svg
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
  >
    <path
      id="prefix__Your_Code"
      d="M4.072 15h-.556A3.52 3.52 0 0 1 0 11.484V3.516A3.52 3.52 0 0 1 3.516 0h7.969A3.52 3.52 0 0 1 15 3.516v2.7a.586.586 0 0 1-1.172 0v-2.7a2.346 2.346 0 0 0-2.344-2.344H3.516a2.346 2.346 0 0 0-2.344 2.344v7.969a2.346 2.346 0 0 0 2.344 2.344h.557a.586.586 0 0 1 0 1.172zm8.584-11.221a.586.586 0 0 0-.586-.586H2.93a.586.586 0 0 0 0 1.172h9.14a.586.586 0 0 0 .586-.586zM15 12.07V10.9a2.933 2.933 0 0 0-2.93-2.93h-.381A2.929 2.929 0 0 0 9 9.727H6.455a3.007 3.007 0 0 0-2.1.866 1.257 1.257 0 0 0 0 1.784 3.007 3.007 0 0 0 2.1.866H9A2.929 2.929 0 0 0 11.689 15h.381A2.933 2.933 0 0 0 15 12.07zM9.42 10.9a.586.586 0 0 0 .567-.44 1.757 1.757 0 0 1 1.7-1.318h.381a1.76 1.76 0 0 1 1.76 1.758v1.17a1.76 1.76 0 0 1-1.758 1.758h-.381a1.757 1.757 0 0 1-1.7-1.318.586.586 0 0 0-.567-.44H6.455a1.826 1.826 0 0 1-1.276-.526.085.085 0 0 1 0-.119 1.827 1.827 0 0 1 1.276-.525zm2.8-.146a.732.732 0 1 0 .732.732.732.732 0 0 0-.735-.734z"
      data-name="Your Code"
    />
  </svg>
);

export const ShowMapIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17.857"
    height="25"
    viewBox="-3 7 22 15"
  >
    <g id="prefix__pin_3_" data-name="pin (3)" transform="translate(-68.265)">
      <g
        id="prefix__Group_2639"
        data-name="Group 2639"
        transform="translate(68.265)"
      >
        <g id="prefix__Group_2638" data-name="Group 2638">
          <path
            id="prefix__Path_77502"
            d="M77.194 0c-5.594 0-8.929 3.671-8.929 9.821 0 6.709 7.964 14.591 8.3 14.923a.893.893 0 0 0 1.25 0c.339-.332 8.3-8.214 8.3-14.923C86.122 3.671 82.785 0 77.194 0zm0 22.822c-1.846-1.97-7.143-8.049-7.143-13 0-5.179 2.537-8.036 7.143-8.036s7.143 2.857 7.143 8.036c0 4.944-5.298 11.03-7.143 13z"
            className="prefix__cls-1"
            data-name="Path 77502"
            transform="translate(-68.265)"
          />
        </g>
      </g>
      <g
        id="prefix__Group_2641"
        data-name="Group 2641"
        transform="translate(72.729 3.571)"
      >
        <g id="prefix__Group_2640" data-name="Group 2640">
          <path
            id="prefix__Path_77503"
            d="M158.063 68.267a4.464 4.464 0 1 0 4.464 4.464 4.464 4.464 0 0 0-4.464-4.464zm0 7.143a2.679 2.679 0 1 1 2.679-2.679 2.679 2.679 0 0 1-2.679 2.679z"
            className="prefix__cls-1"
            data-name="Path 77503"
            transform="translate(-153.599 -68.267)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const NotShowMapIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.954"
    height="25"
    viewBox="0 0 20.954 25"
  >
    <g id="prefix__locked-place" transform="translate(-24.032)">
      <path
        id="prefix__Path_77545"
        d="M92.144 63.529a4.316 4.316 0 1 0-4.316 4.345 4.335 4.335 0 0 0 4.316-4.345zm-4.316 2.618a2.618 2.618 0 1 1 2.59-2.618 2.607 2.607 0 0 1-2.59 2.618z"
        className="prefix__cls-1"
        data-name="Path 77545"
        transform="translate(-54.473 -54.202)"
      />
      <path
        id="prefix__Path_77546"
        d="M44.274 16.166v-2a3.712 3.712 0 0 0-1.731-3.137 11.262 11.262 0 0 0 .134-1.7 9.323 9.323 0 1 0-18.645 0c0 7.662 8.395 15.143 8.752 15.458a.863.863 0 0 0 1.141 0c.112-.1 1.021-.908 2.213-2.209v1.562A.863.863 0 0 0 37 25h7.122a.863.863 0 0 0 .863-.863v-7.122a.863.863 0 0 0-.711-.849zm-1.726-.014h-3.971v-1.985a1.985 1.985 0 0 1 3.971 0zm-9.193 6.8c-1.856-1.8-7.6-7.831-7.6-13.627a7.6 7.6 0 1 1 15.192 0 9.379 9.379 0 0 1-.073 1.143c-.1-.009-.209-.014-.316-.014a3.716 3.716 0 0 0-3.712 3.712v2a.863.863 0 0 0-.712.849v2.905a36.718 36.718 0 0 1-2.779 3.034zm9.905.32h-5.395v-5.4h5.395z"
        className="prefix__cls-1"
        data-name="Path 77546"
      />
    </g>
  </svg>
);

export const AvatarIcon = () => (
  <svg viewBox="0 0 485.211 485.21">
    <g>
      <path d="M394.235,333.585h-30.327c-33.495,0-60.653-27.158-60.653-60.654v-19.484c13.418-15.948,23.042-34.812,29.024-54.745c0.621-3.36,3.855-5.02,6.012-7.33c11.611-11.609,13.894-31.2,5.185-45.149c-1.186-2.117-3.322-3.953-3.201-6.576c0-17.784,0.089-35.596-0.023-53.366c-0.476-21.455-6.608-43.773-21.65-59.66c-12.144-12.836-28.819-20.479-46.022-23.75c-21.739-4.147-44.482-3.937-66.013,1.54c-18.659,4.709-36.189,15.637-47.028,31.836c-9.598,14.083-13.803,31.183-14.513,48.036c-0.266,18.094-0.061,36.233-0.116,54.371c0.413,3.631-2.667,6.088-4.058,9.094c-8.203,14.881-4.592,35.155,8.589,45.978c3.344,2.308,3.97,6.515,5.181,10.142c5.748,17.917,15.282,34.487,27.335,48.925v20.138c0,33.496-27.157,60.654-60.651,60.654H90.978c0,0-54.964,15.158-90.978,90.975v30.327c0,16.759,13.564,30.321,30.327,30.321h424.562 c16.759,0,30.322-13.562,30.322-30.321V424.56C449.199,348.749,394.235,333.585,394.235,333.585z" />
    </g>
  </svg>
);

export const FireCrackerIcon = () => (
  <svg
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g id="prefix__fire-cracker" transform="translate(-16 -16)">
      <path
        id="prefix__Path_77231"
        d="M16.333 174H17a.333.333 0 0 0 .108-.018l12.667-4.333a.333.333 0 0 0 .128-.08l.667-.667a.333.333 0 0 0 0-.471l-8.334-8.331a.333.333 0 0 0-.471 0l-.667.667a.333.333 0 0 0-.072.107l-5 12A.333.333 0 0 0 16 173v.667a.333.333 0 0 0 .333.333zm8.743-3.449l-2.161.739-4.761-1.8.555-1.331zm-6.11-3l.554-1.33 8.694 3.26-2.145.734zm2.959 4.081l-2.131.729-2.45-.919.554-1.329zm7.56-2.586l-.279.1-9.43-3.536.554-1.33 8.218 3.082 1.313 1.313zm-2.076-2.829l-6.822-2.558.554-1.33 3.807 1.428zM22 160.8l1.809 1.809-2.411-.9.217-.521zm-5.333 12.262l.421-1.011 1.713.643-1.857.635h-.278z"
        className="prefix__cls-1"
        data-name="Path 77231"
        transform="translate(0 -138.001)"
      />
      <path
        id="prefix__Path_77232"
        d="M153.764 21.764a.333.333 0 0 0 0 .471l1 1a.333.333 0 0 0 .236.1h.013a.333.333 0 0 0 .24-.116l1.485-1.732a2.473 2.473 0 0 0-1.1-3.955l-.4-.132a3.185 3.185 0 0 1-1.635-1.249.333.333 0 0 0-.462-.092l-1 .667a.333.333 0 0 0-.082.477l.412.549a4.005 4.005 0 0 0 1.624 1.277l.868.372a.6.6 0 0 1 .187.973zm1.469-2.979l-.868-.372a3.338 3.338 0 0 1-1.354-1.064l-.2-.267.442-.294a3.857 3.857 0 0 0 1.782 1.242l.4.132a1.806 1.806 0 0 1 .8 2.889l-1.251 1.459-.51-.51 1.158-1.158a1.265 1.265 0 0 0-.4-2.057z"
        className="prefix__cls-1"
        data-name="Path 77232"
        transform="translate(-130.333)"
      />
      <path
        id="prefix__Path_77233"
        d="M296.117 64.079a.333.333 0 0 0-.112.308l.333 2a.333.333 0 0 0 .537.206l1.667-1.333a.333.333 0 0 0-.1-.577l-2-.667a.333.333 0 0 0-.325.063zm1.53 1.043l-.745.6-.149-.894z"
        className="prefix__cls-1"
        data-name="Path 77233"
        transform="translate(-268.333 -46)"
      />
      <path
        id="prefix__Path_77234"
        d="M0 0h.667v1.374H0z"
        className="prefix__cls-1"
        data-name="Path 77234"
        transform="rotate(-75.936 24.016 -8.328)"
      />
      <path
        id="prefix__Path_77235"
        d="M0 0h1.2v.667H0z"
        className="prefix__cls-1"
        data-name="Path 77235"
        transform="rotate(-33.7 42.324 -40.307)"
      />
      <path
        id="prefix__Path_77236"
        d="M0 0h.667v1.374H0z"
        className="prefix__cls-1"
        data-name="Path 77236"
        transform="rotate(-14.064 88.166 -78.328)"
      />
      <path
        id="prefix__Path_77237"
        d="M327.185 235.722a3.184 3.184 0 0 1-1.249-1.635l-.132-.4a2.473 2.473 0 0 0-3.955-1.1l-1.732 1.485a.333.333 0 0 0-.019.489l1 1a.333.333 0 0 0 .471 0l1.394-1.394a.6.6 0 0 1 .973.187l.372.868a4.005 4.005 0 0 0 1.277 1.624l.549.412a.333.333 0 0 0 .477-.082l.667-1a.333.333 0 0 0-.092-.462zm-.933.8l-.267-.2a3.338 3.338 0 0 1-1.064-1.354l-.372-.868a1.265 1.265 0 0 0-2.057-.4l-1.158 1.158-.51-.51 1.459-1.251a1.806 1.806 0 0 1 2.889.8l.132.4a3.857 3.857 0 0 0 1.242 1.782z"
        className="prefix__cls-1"
        data-name="Path 77237"
        transform="translate(-291.333 -207)"
      />
      <path
        id="prefix__Path_77238"
        d="M410.649 162.228l-.667-2a.333.333 0 0 0-.576-.1l-1.333 1.667a.333.333 0 0 0 .206.537l2 .333a.333.333 0 0 0 .371-.434zm-1.7-.463l.6-.745.3.893z"
        className="prefix__cls-1"
        data-name="Path 77238"
        transform="translate(-375.667 -138)"
      />
      <path
        id="prefix__Path_77239"
        d="M0 0h.667v1.374H0z"
        className="prefix__cls-1"
        data-name="Path 77239"
        transform="rotate(-14.064 120.309 -127.864)"
      />
      <path
        id="prefix__Path_77240"
        d="M0 0h1.2v.667H0z"
        className="prefix__cls-1"
        data-name="Path 77240"
        transform="rotate(-56.29 38.06 -21.383)"
      />
      <path
        id="prefix__Path_77241"
        d="M0 0h.667v1.374H0z"
        className="prefix__cls-1"
        data-name="Path 77241"
        transform="rotate(-75.936 35.016 -5.242)"
      />
      <path
        id="prefix__Path_77242"
        d="M258.324 57.586l-.333-1.333a.333.333 0 0 0-.411-.241l-2.578.7a2.2 2.2 0 0 0-1.571 1.647 2.391 2.391 0 0 1-2.072 1.855h-.038a2.936 2.936 0 0 0-1.912 1.012l-1.328 1.55a.333.333 0 0 0 .017.453l1 1a.333.333 0 0 0 .236.1h.015a.333.333 0 0 0 .241-.12l.9-1.081a2.582 2.582 0 0 1 1.74-.92h.039a3.19 3.19 0 0 0 2.813-2.559l.009-.048a1.543 1.543 0 0 1 1.179-1.209l1.8-.4a.333.333 0 0 0 .251-.406zm-2.2.156a2.21 2.21 0 0 0-1.689 1.731l-.009.048a2.509 2.509 0 0 1-2.225 2.024h-.039a3.245 3.245 0 0 0-2.186 1.158l-.666.8-.524-.524 1.127-1.315a2.272 2.272 0 0 1 1.48-.783h.038a3.058 3.058 0 0 0 2.649-2.373 1.532 1.532 0 0 1 1.1-1.149l2.25-.614.168.671z"
        className="prefix__cls-1"
        data-name="Path 77242"
        transform="translate(-222.333 -38.334)"
      />
    </g>
  </svg>
);

export const BlockIcon = () => (
  <svg viewBox="0 0 510 510">
    <g id="block">
      <path
        d="M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M51,255c0-112.2,91.8-204,204-204
        c45.9,0,89.25,15.3,124.95,43.35l-285.6,285.6C66.3,344.25,51,300.9,51,255z M255,459c-45.9,0-89.25-15.3-124.95-43.35
        L415.65,130.05C443.7,165.75,459,209.1,459,255C459,367.2,367.2,459,255,459z"
      />
    </g>
  </svg>
);

export const UnblockIcon = () => (
  <svg viewBox="0 0 512 512">
    <g>
      <g>
        <path
          d="M437.019,74.98C388.667,26.629,324.38,0,256,0C187.619,0,123.331,26.629,74.98,74.98C26.628,123.332,0,187.62,0,256
          s26.628,132.667,74.98,181.019C123.332,485.371,187.619,512,256,512c68.38,0,132.667-26.629,181.019-74.981
          C485.371,388.667,512,324.38,512,256S485.371,123.333,437.019,74.98z M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30
          s226,101.383,226,226S380.617,482,256,482z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M378.305,173.859c-5.857-5.856-15.355-5.856-21.212,0.001L224.634,306.319l-69.727-69.727
          c-5.857-5.857-15.355-5.857-21.213,0c-5.858,5.857-5.858,15.355,0,21.213l80.333,80.333c2.929,2.929,6.768,4.393,10.606,4.393
          c3.838,0,7.678-1.465,10.606-4.393l143.066-143.066C384.163,189.215,384.163,179.717,378.305,173.859z"
        />
      </g>
    </g>
  </svg>
);

export const TeamIcon = () => (
  <svg
    fill="red"
    xmlns="http://www.w3.org/2000/svg"
    width="34.381"
    height="29"
    viewBox="0 0 34.381 29"
  >
    <g
      id="prefix__group_5_"
      data-name="group (5)"
      transform="translate(0 -25.175)"
    >
      <path
        id="prefix__Path_74117"
        d="M23.733 40.6c.078.034.159.062.3.111.065.025.129.049.2.071a5.38 5.38 0 0 0 1.619.246 5.536 5.536 0 0 0 .56-.029c.058-.007.115-.015.172-.025l.115-.016c.078-.011.158-.021.25-.041.056-.012.111-.027.166-.042l.074-.019c.089-.02.176-.041.279-.072l.232-.084c.087-.029.173-.06.245-.091.043-.016.083-.037.148-.069.111-.051.226-.1.318-.153.034-.016.066-.036.1-.056.1-.058.2-.117.3-.181l.112-.075a5.462 5.462 0 0 0 2.35-4.328v-.144a5.357 5.357 0 0 0-.335-1.861 5.426 5.426 0 0 0-10.5 1.525v.08c-.005.084-.011.169-.011.256v.071a5.426 5.426 0 0 0 3.306 4.926zM21.8 35.433l.005-.091a4.082 4.082 0 0 1 4.039-3.8 4.061 4.061 0 0 1 3.8 2.665A3.986 3.986 0 0 1 29.9 35.5v.1a4 4 0 0 1-.324 1.571 4.053 4.053 0 0 1-1.385 1.729l-.113.078c-.08.053-.163.1-.231.14l-.07.041c-.082.044-.168.082-.252.12l-.107.052c-.055.023-.113.043-.231.084l-.135.051c-.059.018-.118.031-.229.057l-.159.043c-.049.01-.1.016-.148.022l-.255.039a4.058 4.058 0 0 1-1.618-.161c-.041-.013-.078-.028-.117-.043l-.107-.039c-.049-.017-.1-.033-.148-.054A4.075 4.075 0 0 1 21.8 35.6c-.005-.058 0-.112 0-.167zm4.044 5.633A8.483 8.483 0 0 0 19.7 43.7 12.054 12.054 0 0 0 0 53.034c0 .107.006.214.013.318l.032.824h24.028l.038-.8c.007-.112.014-.224.014-.339a12.1 12.1 0 0 0-.247-2.433H34.33l.04-.747c.005-.085.011-.168.011-.253a8.544 8.544 0 0 0-8.534-8.538zM1.376 52.8a10.673 10.673 0 0 1 17.948-7.592c.148.137.29.278.429.422l.166.179a10.685 10.685 0 0 1 1.135 1.47c.055.086.11.172.163.261.095.157.187.315.273.477.043.08.081.161.122.242.157.315.3.637.426.966.028.074.058.146.085.22q.1.279.182.564a10.612 10.612 0 0 1 .444 2.79zM23.5 49.227l-.009-.022a11.994 11.994 0 0 0-.463-1.166c-.029-.065-.062-.127-.092-.19q-.236-.493-.514-.96c-.043-.073-.087-.146-.133-.218q-.29-.466-.622-.9c-.041-.054-.08-.11-.122-.164a12.441 12.441 0 0 0-.848-.975 7.156 7.156 0 0 1 12.3 4.6H23.5zM9.139 39.7c.078.032.159.062.24.091l.231.085c.069.026.137.052.215.077a7.6 7.6 0 0 0 2.253.342 7.26 7.26 0 0 0 .762-.04c.083-.008.165-.021.247-.034l.194-.029c.106-.014.212-.03.308-.05.08-.016.159-.037.238-.058l.145-.036c.115-.027.231-.055.35-.092.055-.017.108-.038.161-.058l.2-.071c.111-.038.221-.078.329-.123.049-.021.1-.043.188-.089.158-.071.317-.144.474-.227.035-.019.069-.04.107-.065.177-.1.352-.2.521-.315l.06-.043a7.556 7.556 0 1 0-11.819-6.7l-.005.086c-.009.13-.018.26-.018.392A7.549 7.549 0 0 0 9.139 39.7zm-3.231-7.26l.006-.094a6.181 6.181 0 1 1 9.676 5.484l-.1.065c-.126.082-.258.158-.4.238l-.069.043c-.127.067-.258.127-.4.188l-.154.074c-.08.034-.164.063-.247.091l-.322.116c-.082.025-.165.044-.247.064l-.191.048c-.049.014-.1.027-.156.039s-.146.025-.219.035l-.229.034c-.05.008-.1.017-.159.023a5.9 5.9 0 0 1-.626.033 6.243 6.243 0 0 1-1.839-.277c-.049-.016-.1-.034-.144-.052l-.256-.094c-.058-.021-.117-.042-.17-.064a6.175 6.175 0 0 1-3.778-5.7c.009-.101.016-.199.023-.297z"
        data-name="Path 74117"
      />
    </g>
  </svg>
);

export const SearchIcon = () => (
  <svg
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
    width="19.995"
    height="20"
    viewBox="0 0 19.995 20"
  >
    <g
      id="prefix__magnifying-glass_5_"
      data-name="magnifying-glass (5)"
      transform="translate(-.05)"
    >
      <path
        id="prefix__Path_74159"
        fill="#323554"
        d="M19.873 18.98l-4.86-4.86a8.534 8.534 0 1 0-.843.843l4.86 4.86a.6.6 0 0 0 .421.177.584.584 0 0 0 .421-.177.6.6 0 0 0 .001-.843zM1.243 8.528a7.33 7.33 0 1 1 7.33 7.335 7.338 7.338 0 0 1-7.33-7.335z"
        data-name="Path 74159"
      />
    </g>
  </svg>
);

export const SendMessageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.52"
    height="20"
    viewBox="0 0 20.52 20"
  >
    <g
      id="prefix__send_2_"
      data-name="send (2)"
      transform="translate(0 -6.197)"
    >
      <g
        id="prefix__Group_2421"
        data-name="Group 2421"
        transform="translate(0 6.197)"
      >
        <path
          id="prefix__Path_77223"
          d="M20.3 15.259a2.15 2.15 0 0 0-1-1L3.087 6.412A2.15 2.15 0 0 0 .154 9.146l2.82 7.05-2.82 7.05a2.15 2.15 0 0 0 2.933 2.735l16.22-7.851a2.15 2.15 0 0 0 .993-2.871zM2.463 24.69a.717.717 0 0 1-.977-.912l2.746-6.866h14.3zm1.769-9.21L1.486 8.614a.716.716 0 0 1 .977-.914l16.072 7.775z"
          data-name="Path 77223"
          transform="translate(0 -6.197)"
        />
      </g>
    </g>
  </svg>
);

export const InviteIcon = () => (
  <svg viewBox="0 0 472.811 472.811">
    <g>
      <path d="M358.75,0H114.061C97.555,0,84.128,13.428,84.128,29.934v412.944c0,16.505,13.428,29.934,29.934,29.934H358.75   c16.506,0,29.934-13.428,29.934-29.934V29.934C388.683,13.428,375.256,0,358.75,0z M99.128,75.236h274.556v312.687H99.128V75.236z    M114.061,15H358.75c8.234,0,14.934,6.699,14.934,14.934v35.302H99.128V29.934C99.128,21.699,105.827,15,114.061,15z    M358.75,457.811H114.061c-8.234,0-14.934-6.699-14.934-14.934v-44.955h274.556v44.955   C373.683,451.112,366.984,457.811,358.75,457.811z" />
      <path d="m236.406,404.552c-13.545,0-24.564,11.02-24.564,24.565s11.02,24.564 24.564,24.564 24.564-11.02 24.564-24.564-11.019-24.565-24.564-24.565zm0,39.129c-8.031,0-14.564-6.534-14.564-14.564 0-8.031 6.533-14.565 14.564-14.565s14.564,6.534 14.564,14.565c0,8.03-6.533,14.564-14.564,14.564z" />
      <path d="m202.406,47.645h68c2.762,0 5-2.239 5-5s-2.238-5-5-5h-68c-2.762,0-5,2.239-5,5s2.238,5 5,5z" />
      <path d="m184.409,47.645c1.31,0 2.6-0.53 3.53-1.46 0.93-0.94 1.47-2.22 1.47-3.54s-0.54-2.6-1.47-3.54c-0.931-0.93-2.221-1.46-3.53-1.46-1.32,0-2.601,0.53-3.54,1.46-0.93,0.93-1.46,2.22-1.46,3.54s0.53,2.6 1.46,3.54c0.93,0.93 2.22,1.46 3.54,1.46z" />
    </g>
  </svg>
);

export const ExportIcon = () => (
  <svg
    fill="white"
    xmlns="http://www.w3.org/2000/svg"
    className="export-icon"
    id="prefix__import_1_"
    width="21.863"
    height="20"
    data-name="import (1)"
    viewBox="0 0 21.863 20"
  >
    <g id="prefix__Group_2691" data-name="Group 2691">
      <path
        id="prefix__Path_77506"
        d="M15.279 33.218a.49.49 0 0 1-.138.018.555.555 0 0 1-.477-.276C12.571 29.271 10.388 29.022 7.9 29v2.209a.548.548 0 0 1-.864.445L.227 26.768a.55.55 0 0 1 0-.891l6.807-4.864a.544.544 0 0 1 .86.445V23.7c3.127.267 5.35 1.488 6.6 3.63a10.622 10.622 0 0 1 1.189 5.359.548.548 0 0 1-.404.529zm-7.956-8.459a.543.543 0 0 1-.517-.543v-1.694l-5.323 3.809 5.323 3.822V28.46a.554.554 0 0 1 .16-.388.546.546 0 0 1 .388-.16c2.4 0 4.86 0 7.123 2.811-.392-2.815-1.897-5.702-7.154-5.964z"
        className="prefix__cls-1"
        data-name="Path 77506"
        transform="translate(6.178 -20.911)"
      />
      <path
        id="prefix__Path_77507"
        d="M99.271 131.385h-2.78v12.936h15.431v-7.836a.546.546 0 1 1 1.091 0v8.383a.548.548 0 0 1-.548.548H95.948a.548.548 0 0 1-.548-.548v-14.031a.548.548 0 0 1 .548-.548h3.328a.548.548 0 0 1 .548.548.554.554 0 0 1-.553.548z"
        className="prefix__cls-1"
        data-name="Path 77507"
        transform="translate(-95.4 -125.417)"
      />
    </g>
  </svg>
);

export const ImportIcon = () => (
  <svg
    fill="white"
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__import_1_"
    width="21.863"
    height="20"
    data-name="import (1)"
    viewBox="0 0 21.863 20"
  >
    <g id="prefix__Group_2691" data-name="Group 2691">
      <path
        id="prefix__Path_77506"
        d="M.405 33.218a.49.49 0 0 0 .138.018.555.555 0 0 0 .477-.276C3.114 29.271 5.3 29.022 7.787 29v2.209a.548.548 0 0 0 .864.445l6.807-4.891a.55.55 0 0 0 0-.891l-6.807-4.86a.544.544 0 0 0-.86.445V23.7c-3.127.267-5.35 1.488-6.6 3.63A10.622 10.622 0 0 0 0 32.692a.548.548 0 0 0 .405.526zm7.956-8.459a.543.543 0 0 0 .517-.543v-1.694l5.322 3.809-5.322 3.822V28.46a.554.554 0 0 0-.16-.388.546.546 0 0 0-.388-.16c-2.4 0-4.86 0-7.123 2.811.393-2.815 1.893-5.702 7.154-5.964z"
        className="prefix__cls-1"
        data-name="Path 77506"
        transform="translate(0 -20.911)"
      />
      <path
        id="prefix__Path_77507"
        d="M109.142 131.385h2.78v12.936H96.491v-7.836a.546.546 0 1 0-1.091 0v8.383a.548.548 0 0 0 .548.548h16.518a.548.548 0 0 0 .548-.548v-14.031a.548.548 0 0 0-.548-.548h-3.328a.548.548 0 0 0-.548.548.554.554 0 0 0 .552.548z"
        className="prefix__cls-1"
        data-name="Path 77507"
        transform="translate(-91.15 -125.417)"
      />
    </g>
  </svg>
);

export const ResendIcon = () => (
  <svg
    fill="black"
    className="icon"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g id="prefix__send_3_" data-name="send (3)" transform="translate(-.001)">
      <g
        id="prefix__Group_1879"
        data-name="Group 1879"
        transform="translate(.001)"
      >
        <g id="prefix__Group_1878" data-name="Group 1878">
          <path
            id="prefix__Path_74177"
            d="M20 .377a.407.407 0 0 0-.016-.067.451.451 0 0 0-.029-.07c-.006-.013-.008-.027-.015-.04a.267.267 0 0 0-.018-.02.451.451 0 0 0-.049-.055.425.425 0 0 0-.056-.049C19.809.071 19.8.064 19.8.06s-.029-.01-.041-.016a.452.452 0 0 0-.073-.029.458.458 0 0 0-.064-.015.446.446 0 0 0-.076 0 .391.391 0 0 0-.07.012.4.4 0 0 0-.045.007L.3 6.543a.434.434 0 0 0-.015.817l8.94 3.435 3.863 8.943a.435.435 0 0 0 .4.262h.012a.435.435 0 0 0 .393-.3L19.986.563a.326.326 0 0 0 .006-.041A.411.411 0 0 0 20 .449a.433.433 0 0 0 0-.072zM1.712 6.978l16.229-5.533-8.5 8.5zm11.709 11.347l-3.357-7.772L18.614 2z"
            className="prefix__cls-1"
            data-name="Path 74177"
            transform="translate(-.002)"
          />
          <path
            id="prefix__Path_74178"
            d="M6.832 240.046a.434.434 0 0 0-.615 0l-6.088 6.088a.435.435 0 1 0 .615.615l6.088-6.088a.434.434 0 0 0 0-.615z"
            className="prefix__cls-1"
            data-name="Path 74178"
            transform="translate(-.001 -226.876)"
          />
          <path
            id="prefix__Path_74179"
            d="M91.173 296.046l-3.044 3.044a.435.435 0 1 0 .615.615l3.044-3.044a.435.435 0 1 0-.615-.615z"
            className="prefix__cls-1"
            data-name="Path 74179"
            transform="translate(-83.217 -279.832)"
          />
          <path
            id="prefix__Path_74180"
            d="M.436 211.832a.434.434 0 0 0 .307-.127l3.044-3.044a.435.435 0 1 0-.615-.615L.129 211.09a.435.435 0 0 0 .307.742z"
            className="prefix__cls-1"
            data-name="Path 74180"
            transform="translate(-.001 -196.616)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const EmailSignInIcon = () => (
  <svg
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
    width="15.002"
    height="15"
    viewBox="0 0 15.002 15"
  >
    <path
      id="prefix__invite"
      d="M13.618 3.794L9.633.755a3.525 3.525 0 0 0-4.265 0L1.384 3.794A3.536 3.536 0 0 0 0 6.59v4.93a3.52 3.52 0 0 0 3.516 3.516h7.97A3.52 3.52 0 0 0 15 11.52V6.59a3.536 3.536 0 0 0-1.384-2.8zm.212 7.726a2.347 2.347 0 0 1-2.344 2.344h-7.97a2.347 2.347 0 0 1-2.344-2.344V6.59a2.358 2.358 0 0 1 .923-1.864L6.08 1.687a2.35 2.35 0 0 1 2.843 0l3.985 3.039a2.358 2.358 0 0 1 .922 1.864zm-1.263-4.281a.586.586 0 0 1-.11.821l-2.824 2.154a3.525 3.525 0 0 1-4.265 0L2.575 8.083a.586.586 0 0 1 .711-.932L6.08 9.282a2.35 2.35 0 0 0 2.843 0l2.823-2.154a.586.586 0 0 1 .821.11z"
      transform="translate(0 -.036)"
    />
  </svg>
);

export const PassSignInIcon = () => (
  <svg
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
    width="13.799"
    height="15"
    viewBox="0 0 13.799 15"
  >
    <path
      id="prefix__user_29_"
      d="M32.717 9.649v-.772a1.758 1.758 0 1 0-3.516 0v.762a2.347 2.347 0 0 0-1.611 2.226v.791A2.346 2.346 0 0 0 29.934 15h2.021a2.346 2.346 0 0 0 2.345-2.344v-.791a2.347 2.347 0 0 0-1.583-2.216zm-1.758-1.358a.587.587 0 0 1 .586.586v.645h-1.172v-.645a.587.587 0 0 1 .586-.586zm2.168 4.365a1.173 1.173 0 0 1-1.172 1.172h-2.021a1.173 1.173 0 0 1-1.172-1.172v-.791a1.173 1.173 0 0 1 1.172-1.172h2.021a1.173 1.173 0 0 1 1.172 1.172zM26.213 7.91a3.955 3.955 0 1 0-3.955-3.955 3.96 3.96 0 0 0 3.955 3.955zm0-6.738a2.783 2.783 0 1 1-2.783 2.783 2.786 2.786 0 0 1 2.783-2.783zm5.5 11.074a.732.732 0 1 1-.732-.732.732.732 0 0 1 .73.732zM27 9.668a.586.586 0 0 1-.586.586h-.586a4.165 4.165 0 0 0-4.16 4.16.586.586 0 0 1-1.172 0 5.338 5.338 0 0 1 5.332-5.332h.586a.586.586 0 0 1 .586.586z"
      data-name="user (29)"
      transform="translate(-20.5)"
    />
  </svg>
);

export const PlusIcon = () => (
  <svg
    fill="white"
    xmlns="http://www.w3.org/2000/svg"
    width="20.2"
    height="20.2"
    viewBox="0 0 20.2 20.2"
  >
    <g id="prefix__plus_2_" data-name="plus (2)" transform="translate(.1 .1)">
      <path
        id="prefix__Path_74160"
        d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0zm0 19.231A9.231 9.231 0 1 1 19.231 10 9.242 9.242 0 0 1 10 19.231z"
        className="prefix__cls-1"
        data-name="Path 74160"
      />
      <path
        id="prefix__Path_74161"
        d="M22.5 17.615h-4.423v-4.23a.385.385 0 1 0-.769 0v4.231h-4.423a.385.385 0 0 0 0 .769h4.423V23a.385.385 0 1 0 .769 0v-4.615H22.5a.385.385 0 1 0 0-.769z"
        className="prefix__cls-1"
        data-name="Path 74161"
        transform="translate(-7.692 -8)"
      />
    </g>
  </svg>
);

export const ChatIcon = () => (
  <svg
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
    width="25.2"
    height="25.278"
    viewBox="0 0 25.2 25.278"
  >
    <g
      id="prefix__comment_1_"
      data-name="comment (1)"
      transform="translate(.1 .1)"
    >
      <g id="prefix___x32__26_">
        <g id="prefix__Group_1300" data-name="Group 1300">
          <path
            id="prefix__Path_74034"
            d="M16.406 13.281H8.594a.781.781 0 0 0 0 1.563h7.812a.781.781 0 0 0 0-1.562zm1.563-4.687H7.031a.781.781 0 0 0 0 1.562h10.938a.781.781 0 1 0 0-1.562zM12.5 0C5.6 0 0 4.9 0 10.937a10.469 10.469 0 0 0 4.688 8.53V25l5.476-3.323a14.335 14.335 0 0 0 2.337.2c6.9 0 12.5-4.9 12.5-10.937S19.4 0 12.5 0zm0 20.312a12.643 12.643 0 0 1-2.641-.287l-3.678 2.212.049-3.623a9.058 9.058 0 0 1-4.668-7.676c0-5.177 4.9-9.375 10.938-9.375s10.938 4.2 10.938 9.375-4.897 9.374-10.938 9.374z"
            data-name="Path 74034"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const PhoneIcon = () => (
  <svg
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
    width="24.964"
    height="25"
    viewBox="0 0 24.964 25"
  >
    <g
      id="prefix__phone-call_6_"
      data-name="phone-call (6)"
      transform="translate(-.344)"
    >
      <g
        id="prefix__Group_2088"
        data-name="Group 2088"
        transform="translate(.344)"
      >
        <path
          id="prefix__Path_77198"
          d="M20.084 41.447a2.459 2.459 0 0 0-1.783-.818 2.543 2.543 0 0 0-1.8.813L14.829 43.1c-.137-.074-.274-.142-.406-.211-.19-.095-.369-.185-.522-.28a18.122 18.122 0 0 1-4.342-3.957 10.691 10.691 0 0 1-1.425-2.248c.433-.4.834-.807 1.224-1.2.148-.148.3-.3.443-.448a2.421 2.421 0 0 0 0-3.651l-1.44-1.44c-.164-.164-.332-.332-.491-.5-.317-.327-.649-.665-.992-.981a2.5 2.5 0 0 0-1.768-.776 2.585 2.585 0 0 0-1.794.776l-.011.011L1.511 30a3.86 3.86 0 0 0-1.145 2.456 9.25 9.25 0 0 0 .675 3.915A22.719 22.719 0 0 0 5.078 43.1a24.83 24.83 0 0 0 8.268 6.474 12.882 12.882 0 0 0 4.643 1.372c.111.005.227.011.332.011a3.976 3.976 0 0 0 3.044-1.309c.005-.011.016-.016.021-.026a12 12 0 0 1 .923-.955c.227-.216.459-.443.686-.681a2.632 2.632 0 0 0 .8-1.826 2.536 2.536 0 0 0-.813-1.81zM21.973 47c-.005 0-.005.005 0 0-.206.222-.417.422-.644.644a13.874 13.874 0 0 0-1.018 1.056 2.544 2.544 0 0 1-1.984.839c-.079 0-.164 0-.243-.005a11.444 11.444 0 0 1-4.115-1.234 23.438 23.438 0 0 1-7.788-6.1 21.421 21.421 0 0 1-3.8-6.326 7.534 7.534 0 0 1-.591-3.3A2.422 2.422 0 0 1 2.519 31l1.8-1.8a1.2 1.2 0 0 1 .8-.375 1.129 1.129 0 0 1 .77.369l.016.016c.322.3.628.612.95.944.164.169.332.338.5.512l1.44 1.44a1.007 1.007 0 0 1 0 1.636c-.153.153-.3.306-.454.454-.443.454-.865.876-1.324 1.287-.011.011-.021.016-.026.026a1.076 1.076 0 0 0-.274 1.2l.016.047a11.565 11.565 0 0 0 1.7 2.781l.005.005a19.366 19.366 0 0 0 4.692 4.268 7.2 7.2 0 0 0 .649.354c.19.095.369.185.522.28.021.011.042.026.063.037a1.144 1.144 0 0 0 .522.132 1.128 1.128 0 0 0 .8-.364l1.8-1.8a1.194 1.194 0 0 1 .8-.4 1.075 1.075 0 0 1 .76.385l.011.011 2.907 2.907A1.043 1.043 0 0 1 21.973 47z"
          className="prefix__cls-1"
          data-name="Path 77198"
          transform="translate(-.344 -25.96)"
        />
        <path
          id="prefix__Path_77199"
          d="M245.53 87.338a6.791 6.791 0 0 1 5.53 5.53.708.708 0 0 0 .7.591.941.941 0 0 0 .121-.011.713.713 0 0 0 .586-.823 8.211 8.211 0 0 0-6.691-6.691.716.716 0 0 0-.823.58.7.7 0 0 0 .577.824z"
          className="prefix__cls-1"
          data-name="Path 77199"
          transform="translate(-232.038 -81.391)"
        />
        <path
          id="prefix__Path_77200"
          d="M260.62 11.028A13.521 13.521 0 0 0 249.6.011a.711.711 0 1 0-.232 1.4 12.077 12.077 0 0 1 9.846 9.846.708.708 0 0 0 .7.591.942.942 0 0 0 .121-.011.7.7 0 0 0 .585-.809z"
          className="prefix__cls-1"
          data-name="Path 77200"
          transform="translate(-235.667)"
        />
      </g>
    </g>
  </svg>
);

export const UploadImgIcon = () => (
  <svg
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path
      id="prefix__add_3_"
      d="M18.214 8.214h-6.071a.357.357 0 0 1-.357-.357V1.786a1.786 1.786 0 1 0-3.571 0v6.071a.357.357 0 0 1-.357.357H1.786a1.786 1.786 0 1 0 0 3.571h6.071a.357.357 0 0 1 .357.357v6.071a1.786 1.786 0 0 0 3.571 0v-6.07a.357.357 0 0 1 .357-.357h6.071a1.786 1.786 0 0 0 0-3.571zm0 0"
      data-name="add"
    />
  </svg>
);

export const CopyIcon = () => (
  <svg viewBox="0 0 510 510">
    <g>
      <g>
        <path
          d="M341.333,85.333H51.2c-28.277,0-51.2,22.923-51.2,51.2v290.133c0,28.277,22.923,51.2,51.2,51.2h290.133
          c28.277,0,51.2-22.923,51.2-51.2V136.533C392.533,108.256,369.61,85.333,341.333,85.333z M358.4,426.667
          c0,9.426-7.641,17.067-17.067,17.067H51.2c-9.426,0-17.067-7.641-17.067-17.067V136.533c0-9.426,7.641-17.067,17.067-17.067
          h290.133c9.426,0,17.067,7.641,17.067,17.067V426.667z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M426.667,0h-307.2c-28.277,0-51.2,22.923-51.2,51.2c0,9.426,7.641,17.067,17.067,17.067S102.4,60.626,102.4,51.2
          s7.641-17.067,17.067-17.067h307.2c9.426,0,17.067,7.641,17.067,17.067v307.2c0,9.426-7.641,17.067-17.067,17.067
          s-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067c28.277,0,51.2-22.923,51.2-51.2V51.2
          C477.867,22.923,454.944,0,426.667,0z"
        />
      </g>
    </g>
  </svg>
);

export const CancelIcon = () => (
  <StyledCancelIcon
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__cancel_5_"
    width="20"
    height="20"
    data-name="cancel (5)"
    viewBox="0 0 20 20"
  >
    <g id="prefix__Group_1893" data-name="Group 1893">
      <path
        id="prefix__Path_74190"
        d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0zm0 18.688A8.688 8.688 0 1 1 18.688 10 8.7 8.7 0 0 1 10 18.688z"
        className="prefix__cls-1"
        data-name="Path 74190"
      />
      <path
        id="prefix__Path_74191"
        d="M137.417 130.879a.655.655 0 0 0-.927 0l-2.346 2.346-2.346-2.346a.656.656 0 1 0-.927.927l2.346 2.346-2.346 2.346a.656.656 0 1 0 .927.927l2.347-2.346 2.346 2.347a.656.656 0 1 0 .927-.927l-2.346-2.346 2.346-2.346a.656.656 0 0 0-.001-.928z"
        className="prefix__cls-1"
        data-name="Path 74191"
        transform="translate(-124.143 -124.152)"
      />
    </g>
  </StyledCancelIcon>
);

export const CheckIcon = () => (
  <svg
    fill="white"
    id="check_2_"
    data-name="check (2)"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g id="Group_2826" data-name="Group 2826">
      <g id="Group_2825" data-name="Group 2825">
        <path
          id="Path_77565"
          data-name="Path 77565"
          d="M10,0A10,10,0,1,0,20,10,10.011,10.011,0,0,0,10,0Zm0,18.451A8.451,8.451,0,1,1,18.451,10,8.461,8.461,0,0,1,10,18.451Z"
        />
      </g>
    </g>
    <g
      id="Group_2828"
      data-name="Group 2828"
      transform="translate(5.159 6.321)"
    >
      <g id="Group_2827" data-name="Group 2827">
        <path
          id="Path_77566"
          data-name="Path 77566"
          d="M141.508,162.025a.775.775,0,0,0-1.094.053l-4.725,5.2-2.283-2.321a.774.774,0,1,0-1.1,1.086l2.857,2.9a.774.774,0,0,0,.552.232h.015a.775.775,0,0,0,.558-.254l5.276-5.809A.775.775,0,0,0,141.508,162.025Z"
          transform="translate(-132.079 -161.824)"
        />
      </g>
    </g>
  </svg>
);

export const GearIcon = () => (
  <svg viewBox="0 0 510 510">
    <g>
      <path
        d="M454.2,189.101l-33.6-5.7c-3.5-11.3-8-22.2-13.5-32.6l19.8-27.7c8.4-11.8,7.1-27.9-3.2-38.1l-29.8-29.8
        c-5.6-5.6-13-8.7-20.9-8.7c-6.2,0-12.1,1.9-17.1,5.5l-27.8,19.8c-10.8-5.7-22.1-10.4-33.8-13.9l-5.6-33.2
        c-2.4-14.3-14.7-24.7-29.2-24.7h-42.1c-14.5,0-26.8,10.4-29.2,24.7l-5.8,34c-11.2,3.5-22.1,8.1-32.5,13.7l-27.5-19.8
        c-5-3.6-11-5.5-17.2-5.5c-7.9,0-15.4,3.1-20.9,8.7l-29.9,29.8c-10.2,10.2-11.6,26.3-3.2,38.1l20,28.1
        c-5.5,10.5-9.9,21.4-13.3,32.7l-33.2,5.6c-14.3,2.4-24.7,14.7-24.7,29.2v42.1c0,14.5,10.4,26.8,24.7,29.2l34,5.8
        c3.5,11.2,8.1,22.1,13.7,32.5l-19.7,27.4c-8.4,11.8-7.1,27.9,3.2,38.1l29.8,29.8c5.6,5.6,13,8.7,20.9,8.7c6.2,0,12.1-1.9,17.1-5.5
        l28.1-20c10.1,5.3,20.7,9.6,31.6,13l5.6,33.6c2.4,14.3,14.7,24.7,29.2,24.7h42.2c14.5,0,26.8-10.4,29.2-24.7l5.7-33.6
        c11.3-3.5,22.2-8,32.6-13.5l27.7,19.8c5,3.6,11,5.5,17.2,5.5l0,0c7.9,0,15.3-3.1,20.9-8.7l29.8-29.8c10.2-10.2,11.6-26.3,3.2-38.1
        l-19.8-27.8c5.5-10.5,10.1-21.4,13.5-32.6l33.6-5.6c14.3-2.4,24.7-14.7,24.7-29.2v-42.1
        C478.9,203.801,468.5,191.501,454.2,189.101z M451.9,260.401c0,1.3-0.9,2.4-2.2,2.6l-42,7c-5.3,0.9-9.5,4.8-10.8,9.9
        c-3.8,14.7-9.6,28.8-17.4,41.9c-2.7,4.6-2.5,10.3,0.6,14.7l24.7,34.8c0.7,1,0.6,2.5-0.3,3.4l-29.8,29.8c-0.7,0.7-1.4,0.8-1.9,0.8
        c-0.6,0-1.1-0.2-1.5-0.5l-34.7-24.7c-4.3-3.1-10.1-3.3-14.7-0.6c-13.1,7.8-27.2,13.6-41.9,17.4c-5.2,1.3-9.1,5.6-9.9,10.8l-7.1,42
        c-0.2,1.3-1.3,2.2-2.6,2.2h-42.1c-1.3,0-2.4-0.9-2.6-2.2l-7-42c-0.9-5.3-4.8-9.5-9.9-10.8c-14.3-3.7-28.1-9.4-41-16.8
        c-2.1-1.2-4.5-1.8-6.8-1.8c-2.7,0-5.5,0.8-7.8,2.5l-35,24.9c-0.5,0.3-1,0.5-1.5,0.5c-0.4,0-1.2-0.1-1.9-0.8l-29.8-29.8
        c-0.9-0.9-1-2.3-0.3-3.4l24.6-34.5c3.1-4.4,3.3-10.2,0.6-14.8c-7.8-13-13.8-27.1-17.6-41.8c-1.4-5.1-5.6-9-10.8-9.9l-42.3-7.2
        c-1.3-0.2-2.2-1.3-2.2-2.6v-42.1c0-1.3,0.9-2.4,2.2-2.6l41.7-7c5.3-0.9,9.6-4.8,10.9-10c3.7-14.7,9.4-28.9,17.1-42
        c2.7-4.6,2.4-10.3-0.7-14.6l-24.9-35c-0.7-1-0.6-2.5,0.3-3.4l29.8-29.8c0.7-0.7,1.4-0.8,1.9-0.8c0.6,0,1.1,0.2,1.5,0.5l34.5,24.6
        c4.4,3.1,10.2,3.3,14.8,0.6c13-7.8,27.1-13.8,41.8-17.6c5.1-1.4,9-5.6,9.9-10.8l7.2-42.3c0.2-1.3,1.3-2.2,2.6-2.2h42.1
        c1.3,0,2.4,0.9,2.6,2.2l7,41.7c0.9,5.3,4.8,9.6,10,10.9c15.1,3.8,29.5,9.7,42.9,17.6c4.6,2.7,10.3,2.5,14.7-0.6l34.5-24.8
        c0.5-0.3,1-0.5,1.5-0.5c0.4,0,1.2,0.1,1.9,0.8l29.8,29.8c0.9,0.9,1,2.3,0.3,3.4l-24.7,34.7c-3.1,4.3-3.3,10.1-0.6,14.7
        c7.8,13.1,13.6,27.2,17.4,41.9c1.3,5.2,5.6,9.1,10.8,9.9l42,7.1c1.3,0.2,2.2,1.3,2.2,2.6v42.1H451.9z"
      />
      <path
        d="M239.4,136.001c-57,0-103.3,46.3-103.3,103.3s46.3,103.3,103.3,103.3s103.3-46.3,103.3-103.3S296.4,136.001,239.4,136.001
        z M239.4,315.601c-42.1,0-76.3-34.2-76.3-76.3s34.2-76.3,76.3-76.3s76.3,34.2,76.3,76.3S281.5,315.601,239.4,315.601z"
      />
    </g>
  </svg>
);

export const BellIcon = () => (
  <svg viewBox="0 0 510 510">
    <g>
      <g>
        <path
          d="M467.819,431.851l-36.651-61.056c-16.896-28.181-25.835-60.437-25.835-93.312V224
            c0-82.325-67.008-149.333-149.333-149.333S106.667,141.675,106.667,224v53.483c0,32.875-8.939,65.131-25.835,93.312
            l-36.651,61.056c-1.984,3.285-2.027,7.403-0.149,10.731c1.899,3.349,5.461,5.419,9.301,5.419h405.333
            c3.84,0,7.403-2.069,9.301-5.419C469.845,439.253,469.803,435.136,467.819,431.851z M72.171,426.667l26.944-44.907
            C118.016,350.272,128,314.219,128,277.483V224c0-70.592,57.408-128,128-128s128,57.408,128,128v53.483
            c0,36.736,9.984,72.789,28.864,104.277l26.965,44.907H72.171z"
        />
      </g>
      <g>
        <path
          d="M256,0c-23.531,0-42.667,19.136-42.667,42.667v42.667C213.333,91.221,218.112,96,224,96s10.667-4.779,10.667-10.667
            V42.667c0-11.776,9.557-21.333,21.333-21.333s21.333,9.557,21.333,21.333v42.667C277.333,91.221,282.112,96,288,96
            s10.667-4.779,10.667-10.667V42.667C298.667,19.136,279.531,0,256,0z"
        />
      </g>
      <g>
        <path
          d="M302.165,431.936c-3.008-5.077-9.515-6.741-14.613-3.819c-5.099,2.987-6.805,9.536-3.819,14.613
            c2.773,4.715,4.288,10.368,4.288,15.936c0,17.643-14.357,32-32,32c-17.643,0-32-14.357-32-32c0-5.568,1.515-11.221,4.288-15.936
            c2.965-5.099,1.259-11.627-3.819-14.613c-5.141-2.923-11.627-1.259-14.613,3.819c-4.715,8.064-7.211,17.301-7.211,26.731
            C202.667,488.085,226.581,512,256,512s53.333-23.915,53.376-53.333C309.376,449.237,306.88,440,302.165,431.936z"
        />
      </g>
    </g>
  </svg>
);

export const NewShiftIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30.8"
    height="30.8"
    viewBox="0 0 30.8 30.8"
  >
    <g id="prefix__plus_18_" data-name="plus (18)" transform="translate(.4 .4)">
      <g id="prefix__Group_2692" data-name="Group 2692">
        <path
          id="prefix__Path_77508"
          d="M26.84 0H3.16A3.164 3.164 0 0 0 0 3.16v23.68A3.164 3.164 0 0 0 3.16 30h23.68A3.164 3.164 0 0 0 30 26.84V3.16A3.168 3.168 0 0 0 26.84 0zm1.66 26.84a1.665 1.665 0 0 1-1.66 1.66H3.16a1.665 1.665 0 0 1-1.66-1.66V3.16A1.665 1.665 0 0 1 3.16 1.5h23.68a1.665 1.665 0 0 1 1.66 1.66v23.68z"
          className="prefix__cls-1"
          data-name="Path 77508"
        />
        <path
          id="prefix__Path_77509"
          d="M152 145.772h-4.918v-4.918a.753.753 0 1 0-1.507 0v4.918h-4.918a.75.75 0 1 0 0 1.5h4.918v4.918a.753.753 0 0 0 1.507 0v-4.918H152a.75.75 0 1 0 0-1.5z"
          className="prefix__cls-1"
          data-name="Path 77509"
          transform="translate(-131.331 -131.519)"
        />
      </g>
    </g>
  </svg>
);

export const TooltipCancelIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      fill="#006FCF"
      fillRule="evenodd"
      d="M7.997 0a7.997 7.997 0 1 1 0 15.993A7.997 7.997 0 0 1 7.997 0zm0 14.993a7.005 7.005 0 0 0 6.996-6.996A7.005 7.005 0 0 0 7.997 1 7.005 7.005 0 0 0 1 7.997a7.005 7.005 0 0 0 6.997 6.996zm3.533-10.53a1.003 1.003 0 0 1 0 1.414L9.41 7.998l2.121 2.121a1.003 1.003 0 0 1 0 1.415 1.003 1.003 0 0 1-1.414 0L7.995 9.412l-2.122 2.122a1.003 1.003 0 0 1-1.414 0 1.003 1.003 0 0 1 0-1.415l2.122-2.121-2.122-2.121a1.003 1.003 0 0 1 0-1.415 1.003 1.003 0 0 1 1.414 0l2.122 2.122 2.121-2.122a1.003 1.003 0 0 1 1.414 0z"
    />
  </svg>
);

export const TooltipInfoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#0058A3"
        d="M7.997 0a7.998 7.998 0 0 1 7.996 8c0 4.418-3.58 8-7.996 8A7.998 7.998 0 0 1 0 8c0-4.418 3.58-8 7.997-8zm0 15c3.858 0 6.996-3.14 6.996-7s-3.138-7-6.996-7C4.139 1 1 4.14 1 8s3.139 7 6.997 7zm-.002-9.001c.55 0 1 .45 1 1v5.002c0 .55-.45 1-1 1s-1-.45-1-1V7c0-.55.45-1 1-1zm0-.873a1.125 1.125 0 1 1 0-2.251 1.125 1.125 0 0 1 0 2.25z"
      />
    </g>
  </svg>
);

export const AddWorkerIcon = () => (
  <svg
    className="icon"
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__follow"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g
      id="prefix__Group_2633"
      data-name="Group 2633"
      transform="translate(12.552)"
    >
      <g id="prefix__Group_2632" data-name="Group 2632">
        <path
          id="prefix__Path_77499"
          d="M328.2 3.138h-2.552V.586a.586.586 0 0 0-1.172 0v2.552h-2.556a.586.586 0 1 0 0 1.172h2.552v2.552a.586.586 0 0 0 1.172 0V4.31h2.556a.586.586 0 1 0 0-1.172z"
          className="prefix__cls-1"
          data-name="Path 77499"
          transform="translate(-321.334)"
        />
      </g>
    </g>
    <g
      id="prefix__Group_2635"
      data-name="Group 2635"
      transform="translate(0 12.552)"
    >
      <g id="prefix__Group_2634" data-name="Group 2634">
        <path
          id="prefix__Path_77500"
          d="M6.862 321.334A6.87 6.87 0 0 0 0 328.2a.586.586 0 0 0 .586.586h12.552a.586.586 0 0 0 .586-.586 6.87 6.87 0 0 0-6.862-6.866zM1.2 327.61a5.69 5.69 0 0 1 11.32 0z"
          className="prefix__cls-1"
          data-name="Path 77500"
          transform="translate(0 -321.334)"
        />
      </g>
    </g>
    <g
      id="prefix__Group_2637"
      data-name="Group 2637"
      transform="translate(3.138 2.51)"
    >
      <g id="prefix__Group_2636" data-name="Group 2636">
        <path
          id="prefix__Path_77501"
          d="M84.058 64.267a3.724 3.724 0 1 0 3.724 3.724 3.728 3.728 0 0 0-3.724-3.724zm0 6.276a2.552 2.552 0 1 1 2.552-2.552 2.555 2.555 0 0 1-2.552 2.552z"
          className="prefix__cls-1"
          data-name="Path 77501"
          transform="translate(-80.334 -64.267)"
        />
      </g>
    </g>
  </svg>
);

export const HomeNavIcon = () => {
  return (
    <svg
      fill="#ffffff"
      xmlns="http://www.w3.org/2000/svg"
      width="28.396"
      height="25.321"
      viewBox="0 0 28.396 25.321"
    >
      <g id="prefix__home" transform="translate(.2 -27.627)">
        <g
          id="prefix__Group_16"
          data-name="Group 16"
          transform="translate(-.001 27.798)"
        >
          <g id="prefix__Group_15" data-name="Group 15">
            <path
              id="prefix__Path_14"
              d="M27.747 37.672l-13.294-9.734a.729.729 0 0 0-.861 0L.3 37.672a.729.729 0 0 0 .861 1.176l12.864-9.419 12.864 9.418a.729.729 0 0 0 .861-1.176z"
              className="prefix__cls-1"
              data-name="Path 14"
              transform="translate(.001 -27.797)"
            />
          </g>
        </g>
        <g
          id="prefix__Group_18"
          data-name="Group 18"
          transform="translate(3.092 35.853)"
        >
          <g id="prefix__Group_17" data-name="Group 17">
            <path
              id="prefix__Path_15"
              d="M77.584 230.675c-.4 0-.729-.936-.729-.534v15.387h-5.829v-5.069a3.644 3.644 0 0 0-7.287 0v5.069h-5.83v-15.387c0-.4-.326.534-.729.534a.729.729 0 0 0-.729.729v14.853a.729.729 0 0 0 .729.729h7.287a.728.728 0 0 0 .726-.672.552.552 0 0 0 0-.057v-5.8a2.186 2.186 0 0 1 4.373 0v5.8a.534.534 0 0 0 0 .056.728.728 0 0 0 .726.673h7.287a.729.729 0 0 0 .729-.729V231.4a.729.729 0 0 0-.724-.725z"
              className="prefix__cls-1"
              data-name="Path 15"
              transform="translate(-56.452 -230.041)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ShiftsNavIcon = () => {
  return (
    <svg
      fill="#ffffff"
      xmlns="http://www.w3.org/2000/svg"
      width="24.951"
      height="25"
      viewBox="0 0 24.951 25"
    >
      <g id="prefix__my_jobs" data-name="my jobs" transform="translate(-.5)">
        <g
          id="prefix__Group_2239"
          data-name="Group 2239"
          transform="translate(11.262 10.945)"
        >
          <ellipse
            id="prefix__Ellipse_576"
            cx="1.22"
            cy="1.217"
            className="prefix__cls-1"
            data-name="Ellipse 576"
            rx="1.22"
            ry="1.217"
            transform="rotate(-45.04 2.083 .864)"
          />
        </g>
        <g
          id="prefix__Group_2240"
          data-name="Group 2240"
          transform="translate(.5 6.287)"
        >
          <path
            id="prefix__Path_77294"
            d="M19.6 147.713H6.348A5.855 5.855 0 0 1 .5 141.866v-7.018A5.855 5.855 0 0 1 6.348 129H19.6a5.855 5.855 0 0 1 5.848 5.848v7.018a5.855 5.855 0 0 1-5.848 5.847zM6.348 130.949a3.9 3.9 0 0 0-3.9 3.9v7.018a3.9 3.9 0 0 0 3.9 3.9H19.6a3.9 3.9 0 0 0 3.9-3.9v-7.018a3.9 3.9 0 0 0-3.9-3.9z"
            className="prefix__cls-1"
            data-name="Path 77294"
            transform="translate(-.5 -129)"
          />
        </g>
        <g
          id="prefix__Group_2241"
          data-name="Group 2241"
          transform="translate(5.276 12.135)"
        >
          <path
            id="prefix__Path_77295"
            d="M108.588 255.287h-4.776a5.318 5.318 0 0 1-5.312-5.312.975.975 0 1 1 1.949 0 3.366 3.366 0 0 0 3.363 3.363h4.776a3.366 3.366 0 0 0 3.363-3.363.975.975 0 1 1 1.949 0 5.318 5.318 0 0 1-5.312 5.312z"
            className="prefix__cls-1"
            data-name="Path 77295"
            transform="translate(-98.5 -249)"
          />
        </g>
        <g
          id="prefix__Group_2242"
          data-name="Group 2242"
          transform="translate(8.346)"
        >
          <path
            id="prefix__Path_77296"
            d="M169.785 4.337a.975.975 0 0 1-.975-.975 1.415 1.415 0 0 0-1.41-1.413h-2.534a1.415 1.415 0 0 0-1.413 1.413.975.975 0 1 1-1.949 0A3.366 3.366 0 0 1 164.863 0h2.537a3.366 3.366 0 0 1 3.363 3.363.975.975 0 0 1-.978.974z"
            className="prefix__cls-1"
            data-name="Path 77296"
            transform="translate(-161.5)"
          />
        </g>
      </g>
    </svg>
  );
};

export const ReportsNavIcon = () => {
  return (
    <svg
      fill="#ffffff"
      xmlns="http://www.w3.org/2000/svg"
      width="25.001"
      height="25.001"
      viewBox="0 0 25.001 25.001"
    >
      <path
        id="prefix__line-chart_2_"
        d="M3.613 25A3.617 3.617 0 0 1 0 21.388V12.11a3.613 3.613 0 0 1 7.227 0v9.278A3.617 3.617 0 0 1 3.613 25zm0-14.551a1.662 1.662 0 0 0-1.66 1.66v9.278a1.66 1.66 0 1 0 3.32 0V12.11a1.662 1.662 0 0 0-1.66-1.66zM12.5 25a3.617 3.617 0 0 1-3.613-3.613v-4a3.613 3.613 0 0 1 7.227 0v4A3.617 3.617 0 0 1 12.5 25zm0-9.278a1.662 1.662 0 0 0-1.66 1.66v4a1.66 1.66 0 0 0 3.32 0v-4a1.662 1.662 0 0 0-1.66-1.659zM21.388 25a3.617 3.617 0 0 1-3.613-3.613v-8.545a3.613 3.613 0 1 1 7.227 0v8.545A3.617 3.617 0 0 1 21.388 25zm0-13.819a1.662 1.662 0 0 0-1.66 1.66v8.545a1.66 1.66 0 0 0 3.32 0v-8.544a1.662 1.662 0 0 0-1.66-1.66zm-5.43-.388l5.4-5.677a.977.977 0 1 0-1.41-1.346l-5.413 5.686-.019.02a1.468 1.468 0 0 1-1.975.187l-6.2-5.633-.051-.043a3.41 3.41 0 0 0-4.406.14l-.034.032L.29 5.7a.977.977 0 0 0 1.373 1.391l1.542-1.525a1.461 1.461 0 0 1 1.85-.066l6.2 5.633.051.043a3.425 3.425 0 0 0 4.651-.384zM25 5.567V2.93A2.933 2.933 0 0 0 22.071 0h-2.637a.977.977 0 0 0 0 1.953h2.637a.978.978 0 0 1 .977.977v2.637a.977.977 0 1 0 1.953 0z"
        data-name="line-chart (2)"
      />
    </svg>
  );
};


export const JobReportsNavIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.6426 21.625H7.20948C6.719 21.625 6.2486 21.4302 5.90178 21.0833C5.55495 20.7365 5.36011 20.2661 5.36011 19.7756V2.84938C5.36011 2.35889 5.55495 1.88849 5.90178 1.54167C6.2486 1.19484 6.719 1 7.20948 1H12.4551C12.9246 1.00096 13.3774 1.17471 13.727 1.48813L19.8457 6.98813C20.0469 7.16808 20.2079 7.38847 20.318 7.63488C20.4282 7.8813 20.4852 8.1482 20.4851 8.41812V19.7756C20.4851 20.2649 20.2912 20.7343 19.9459 21.0809C19.6005 21.4275 19.1319 21.6232 18.6426 21.625V21.625ZM7.20948 2.375C7.08367 2.375 6.96301 2.42498 6.87405 2.51394C6.78509 2.6029 6.73511 2.72356 6.73511 2.84938V19.7756C6.73511 19.9014 6.78509 20.0221 6.87405 20.1111C6.96301 20.2 7.08367 20.25 7.20948 20.25H18.6426C18.7684 20.25 18.8891 20.2 18.978 20.1111C19.067 20.0221 19.117 19.9014 19.117 19.7756V8.38375C19.1168 8.30846 19.1009 8.23404 19.0701 8.16534C19.0393 8.09664 18.9943 8.03519 18.9382 7.985L12.8195 2.485C12.7156 2.40501 12.5859 2.36588 12.4551 2.375H7.20948Z" />
      <path d="M14.249 16.1402L16.2185 14.3209V14.391C16.2185 14.7158 16.5036 14.9792 16.8553 14.9792C17.2069 14.9792 17.492 14.7158 17.492 14.391C17.492 12.727 17.495 12.8819 17.4847 12.8162C17.4397 12.5284 17.1726 12.3124 16.8551 12.3125H15.2421C14.8905 12.3125 14.6054 12.5759 14.6054 12.9007C14.6054 13.2256 14.8905 13.4889 15.2421 13.4889H15.318L13.7988 14.8924L11.8718 13.1122C11.6232 12.8825 11.22 12.8825 10.9713 13.1122L8.67894 15.2299C8.43026 15.4596 8.43026 15.8321 8.67894 16.0618C8.92757 16.2915 9.33077 16.2915 9.57945 16.0618L11.4216 14.3601L13.3486 16.1402C13.5972 16.3699 14.0004 16.37 14.249 16.1402Z" />
      <path d="M19.7976 8.52126H13.7407C13.3414 8.52126 12.9585 8.36263 12.6761 8.08027C12.3937 7.79791 12.2351 7.41495 12.2351 7.01563V2.07251H13.6101V7.01563C13.6101 7.05028 13.6239 7.0835 13.6484 7.108C13.6729 7.1325 13.7061 7.14626 13.7407 7.14626H19.7976V8.52126Z" />
      <path d="M2.71187 18.6413C2.25716 18.6359 1.8228 18.4519 1.50253 18.129C1.18227 17.8062 1.00177 17.3704 1 16.9156V5.7094C0.999948 5.4545 1.05659 5.20278 1.16583 4.97248C1.27506 4.74217 1.43416 4.53905 1.63158 4.37782C1.82901 4.21659 2.05982 4.10129 2.30731 4.04027C2.55479 3.97925 2.81275 3.97404 3.0625 4.02502L6.54062 4.27252L6.31375 5.64752L2.82188 5.3794C2.76795 5.36477 2.71138 5.36274 2.65654 5.37347C2.6017 5.3842 2.55007 5.4074 2.50563 5.44127C2.46511 5.47328 2.43233 5.51401 2.40972 5.56043C2.3871 5.60685 2.37524 5.65776 2.375 5.7094V16.9156C2.37601 16.9669 2.38827 17.0174 2.4109 17.0634C2.43353 17.1094 2.46599 17.1499 2.50598 17.1821C2.54597 17.2142 2.59252 17.2372 2.64235 17.2493C2.69218 17.2615 2.74408 17.2626 2.79438 17.2525L6.34812 17.0463L6.52688 18.4213L3.02125 18.6206C2.91916 18.6386 2.81544 18.6455 2.71187 18.6413Z" />
    </svg>
  );
};


export const DashboardNavIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.47911 7.33339H1.60411C0.719559 7.33339 0 6.61383 0 5.72911V1.60411C0 0.719559 0.719559 0 1.60411 0H8.47911C9.36383 0 10.0834 0.719559 10.0834 1.60411V5.72911C10.0834 6.61383 9.36383 7.33339 8.47911 7.33339ZM1.60411 1.375C1.47772 1.375 1.375 1.47772 1.375 1.60411V5.72911C1.375 5.85567 1.47772 5.95839 1.60411 5.95839H8.47911C8.60567 5.95839 8.70839 5.85567 8.70839 5.72911V1.60411C8.70839 1.47772 8.60567 1.375 8.47911 1.375H1.60411Z" />
      <path d="M8.47911 22H1.60411C0.719559 22 0 21.2805 0 20.3959V10.7709C0 9.88618 0.719559 9.16663 1.60411 9.16663H8.47911C9.36383 9.16663 10.0834 9.88618 10.0834 10.7709V20.3959C10.0834 21.2805 9.36383 22 8.47911 22ZM1.60411 10.5416C1.47772 10.5416 1.375 10.6443 1.375 10.7709V20.3959C1.375 20.5223 1.47772 20.625 1.60411 20.625H8.47911C8.60567 20.625 8.70839 20.5223 8.70839 20.3959V10.7709C8.70839 10.6443 8.60567 10.5416 8.47911 10.5416H1.60411Z" />
      <path d="M20.3958 22H13.5208C12.6361 22 11.9165 21.2805 11.9165 20.3959V16.2709C11.9165 15.3862 12.6361 14.6666 13.5208 14.6666H20.3958C21.2803 14.6666 21.9999 15.3862 21.9999 16.2709V20.3959C21.9999 21.2805 21.2803 22 20.3958 22V22ZM13.5208 16.0416C13.3942 16.0416 13.2915 16.1443 13.2915 16.2709V20.3959C13.2915 20.5223 13.3942 20.625 13.5208 20.625H20.3958C20.5222 20.625 20.6249 20.5223 20.6249 20.3959V16.2709C20.6249 16.1443 20.5222 16.0416 20.3958 16.0416H13.5208Z" />
      <path d="M20.3958 12.8334H13.5208C12.6361 12.8334 11.9165 12.1138 11.9165 11.2291V1.60411C11.9165 0.719559 12.6361 0 13.5208 0H20.3958C21.2803 0 21.9999 0.719559 21.9999 1.60411V11.2291C21.9999 12.1138 21.2803 12.8334 20.3958 12.8334V12.8334ZM13.5208 1.375C13.3942 1.375 13.2915 1.47772 13.2915 1.60411V11.2291C13.2915 11.3557 13.3942 11.4584 13.5208 11.4584H20.3958C20.5222 11.4584 20.6249 11.3557 20.6249 11.2291V1.60411C20.6249 1.47772 20.5222 1.375 20.3958 1.375H13.5208Z" />
    </svg>
  );
};

export const MessagesNavIcon = () => {
  return (
    <svg
      fill="#ffffff"
      xmlns="http://www.w3.org/2000/svg"
      id="prefix__Message"
      width="25.001"
      height="25.001"
      viewBox="0 0 25.001 25.001"
    >
      <g id="prefix___x32__26_">
        <g id="prefix__Group_1300" data-name="Group 1300">
          <path
            id="prefix__Path_74034"
            d="M16.407 13.282H8.594a.781.781 0 1 0 0 1.563h7.813a.781.781 0 1 0 0-1.563zm1.563-4.688H7.032a.781.781 0 0 0 0 1.563h10.937a.781.781 0 0 0 0-1.563zM12.5 0C5.6 0 0 4.9 0 10.938a10.47 10.47 0 0 0 4.688 8.531V25l5.476-3.323a14.335 14.335 0 0 0 2.337.2c6.9 0 12.5-4.9 12.5-10.938S19.4 0 12.5 0zm0 20.313a12.643 12.643 0 0 1-2.641-.287l-3.678 2.212.049-3.624a9.059 9.059 0 0 1-4.668-7.676c0-5.178 4.9-9.375 10.938-9.375s10.938 4.2 10.938 9.375-4.897 9.375-10.938 9.375z"
            data-name="Path 74034"
          />
        </g>
      </g>
    </svg>
  );
};

export const WorkersNavIcon = () => {
  return (
    <svg
      fill="#ffffff"
      xmlns="http://www.w3.org/2000/svg"
      width="19.739"
      height="25.501"
      viewBox="0 0 19.739 25.501"
    >
      <g
        id="prefix__person_2_"
        data-name="person (2)"
        transform="translate(-58.75 .25)"
      >
        <g
          id="prefix__Group_2503"
          data-name="Group 2503"
          transform="translate(59 15.137)"
        >
          <path
            id="prefix__Path_77317"
            d="M77.262 319.864a.977.977 0 0 1-.977-.977 6.942 6.942 0 0 0-6.934-6.934h-1.464a6.942 6.942 0 0 0-6.934 6.934.977.977 0 1 1-1.953 0A8.9 8.9 0 0 1 67.887 310h1.465a8.9 8.9 0 0 1 8.887 8.887.977.977 0 0 1-.977.977z"
            className="prefix__cls-1"
            data-name="Path 77317"
            transform="translate(-59 -310)"
          />
        </g>
        <g
          id="prefix__Group_2504"
          data-name="Group 2504"
          transform="translate(61.93)"
        >
          <path
            id="prefix__Path_77318"
            d="M125.592 13.184a6.592 6.592 0 1 1 6.592-6.592 6.6 6.6 0 0 1-6.592 6.592zm0-11.231a4.639 4.639 0 1 0 4.639 4.639 4.644 4.644 0 0 0-4.639-4.639z"
            className="prefix__cls-1"
            data-name="Path 77318"
            transform="translate(-119)"
          />
        </g>
      </g>
    </svg>
  );
};

export const FacilitiesNavIcon = () => {
  return (
    <svg
      fill="#ffffff"
      xmlns="http://www.w3.org/2000/svg"
      width="25.006"
      height="25.001"
      viewBox="0 0 25.006 25.001"
    >
      <g
        id="prefix__building_2_"
        data-name="building (2)"
        transform="translate(0 -.05)"
      >
        <path
          id="prefix__Path_77297"
          d="M23.736 23.586V6.733h-5.3V4.354h-1.904v-2.7h-3.3V.05H11.77v1.6h-3.3v2.7H6.568v2.383H1.27v16.853H0v1.465h25.006v-1.465zM22.271 8.2v15.386h-3.834V19.95h2.006v-1.465h-2.006v-1.466h2.006v-1.465h-2.006v-1.465h2.006v-1.466h-2.006v-1.465h2.006V9.693h-2.006V8.2zM9.939 3.116h5.128v1.238H9.939zm7.033 2.7v17.77h-3.736v-1.715H11.77v1.715H8.034V5.819zM2.735 8.2h3.833v1.493H4.6v1.465h1.968v1.465H4.6v1.465h1.968v1.465H4.6v1.465h1.968v1.465H4.6v1.467h1.968v3.636H2.735z"
          className="prefix__cls-1"
          data-name="Path 77297"
        />
        <path
          id="prefix__Path_77298"
          d="M206.5 155.831h1.563v1.469H206.5z"
          className="prefix__cls-1"
          data-name="Path 77298"
          transform="translate(-196.415 -148.173)"
        />
        <path
          id="prefix__Path_77299"
          d="M273.5 155.831h1.563v1.469H273.5z"
          className="prefix__cls-1"
          data-name="Path 77299"
          transform="translate(-260.142 -148.173)"
        />
        <path
          id="prefix__Path_77300"
          d="M206.5 215.831h1.563v1.469H206.5z"
          className="prefix__cls-1"
          data-name="Path 77300"
          transform="translate(-196.415 -205.242)"
        />
        <path
          id="prefix__Path_77301"
          d="M273.5 215.831h1.563v1.469H273.5z"
          className="prefix__cls-1"
          data-name="Path 77301"
          transform="translate(-260.142 -205.242)"
        />
        <path
          id="prefix__Path_77302"
          d="M206.5 275.831h1.563v1.469H206.5z"
          className="prefix__cls-1"
          data-name="Path 77302"
          transform="translate(-196.415 -262.312)"
        />
        <path
          id="prefix__Path_77303"
          d="M273.5 275.831h1.563v1.469H273.5z"
          className="prefix__cls-1"
          data-name="Path 77303"
          transform="translate(-260.142 -262.312)"
        />
        <path
          id="prefix__Path_77304"
          d="M206.5 335.831h1.563v1.469H206.5z"
          className="prefix__cls-1"
          data-name="Path 77304"
          transform="translate(-196.415 -319.382)"
        />
        <path
          id="prefix__Path_77305"
          d="M273.5 335.831h1.563v1.469H273.5z"
          className="prefix__cls-1"
          data-name="Path 77305"
          transform="translate(-260.142 -319.382)"
        />
        <path
          id="prefix__Path_77306"
          d="M206.5 395.831h1.563v1.469H206.5z"
          className="prefix__cls-1"
          data-name="Path 77306"
          transform="translate(-196.415 -376.451)"
        />
        <path
          id="prefix__Path_77307"
          d="M273.5 395.831h1.563v1.469H273.5z"
          className="prefix__cls-1"
          data-name="Path 77307"
          transform="translate(-260.142 -376.451)"
        />
      </g>
    </svg>
  );
};

export const TeamsNavIcon = () => {
  return (
    <svg
      fill="#ffffff"
      xmlns="http://www.w3.org/2000/svg"
      width="30.001"
      height="25.001"
      viewBox="0 0 30.001 25.001"
    >
      <g
        id="prefix__Group_2535"
        data-name="Group 2535"
        transform="translate(-106.666 -85.333)"
      >
        <g
          id="prefix__Group_2506"
          data-name="Group 2506"
          transform="translate(111.666 85.333)"
        >
          <g id="prefix__Group_2505" data-name="Group 2505">
            <path
              id="prefix__Path_77319"
              d="M176.5 85.333a5.834 5.834 0 1 0 5.834 5.834 5.84 5.84 0 0 0-5.834-5.834zm0 10a4.167 4.167 0 1 1 4.167-4.167 4.173 4.173 0 0 1-4.167 4.167z"
              className="prefix__cls-1"
              data-name="Path 77319"
              transform="translate(-170.666 -85.333)"
            />
          </g>
        </g>
        <g
          id="prefix__Group_2508"
          data-name="Group 2508"
          transform="translate(125 92)"
        >
          <g id="prefix__Group_2507" data-name="Group 2507">
            <path
              id="prefix__Path_77320"
              d="M345.5 170.667a4.167 4.167 0 1 0 4.167 4.167 4.173 4.173 0 0 0-4.167-4.167zm0 6.667a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5z"
              className="prefix__cls-1"
              data-name="Path 77320"
              transform="translate(-341.334 -170.667)"
            />
          </g>
        </g>
        <g
          id="prefix__Group_2510"
          data-name="Group 2510"
          transform="translate(106.666 98.667)"
        >
          <g id="prefix__Group_2509" data-name="Group 2509">
            <path
              id="prefix__Path_77321"
              d="M117.5 256a10.846 10.846 0 0 0-10.834 10.834.833.833 0 0 0 1.667 0 9.167 9.167 0 1 1 18.334 0 .833.833 0 0 0 1.667 0A10.846 10.846 0 0 0 117.5 256z"
              className="prefix__cls-1"
              data-name="Path 77321"
              transform="translate(-106.666 -256)"
            />
          </g>
        </g>
        <g
          id="prefix__Group_2512"
          data-name="Group 2512"
          transform="translate(124.881 102)"
        >
          <g id="prefix__Group_2511" data-name="Group 2511">
            <path
              id="prefix__Path_77322"
              d="M344.1 298.667a7.5 7.5 0 0 0-3.885 1.083.834.834 0 1 0 .865 1.425 5.835 5.835 0 0 1 8.854 4.992.833.833 0 0 0 1.667 0 7.51 7.51 0 0 0-7.501-7.5z"
              className="prefix__cls-1"
              data-name="Path 77322"
              transform="translate(-339.813 -298.667)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const BadgesNavIcon = () => {
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 20 30.3">
      <path className="st0" d="M20,10c0-5.5-4.5-10-10-10S0,4.5,0,10c0,3.3,1.6,6.2,4.1,8L2.6,29.1c-0.1,0.4,0.1,0.8,0.4,1
	c0.2,0.1,0.4,0.2,0.5,0.2c0.2,0,0.4,0,0.5-0.1l5.9-3.5l5.9,3.5c0.3,0.2,0.7,0.2,1.1,0c0.3-0.2,0.5-0.6,0.4-1L15.9,18
	C18.4,16.2,20,13.3,20,10z M2,10c0-4.4,3.6-8,8-8s8,3.6,8,8s-3.6,8-8,8S2,14.4,2,10z M15.2,27.4l-4.6-2.8c-0.3-0.2-0.7-0.2-1,0
	l-4.6,2.8l1.1-8.2C7.2,19.7,8.5,20,10,20c1.5,0,2.8-0.3,4.1-0.9L15.2,27.4z"/>
    </svg>
  );
};

export const EmployersNavIcon = () => {
  return (
    <svg
      fill="#ffffff"
      xmlns="http://www.w3.org/2000/svg"
      width="38.335"
      height="25.001"
      viewBox="0 0 38.335 25.001"
    >
      <g
        id="prefix__user_33_"
        data-name="user (33)"
        transform="translate(0 -85.333)"
      >
        <g
          id="prefix__Group_2515"
          data-name="Group 2515"
          transform="translate(13.334 85.333)"
        >
          <g id="prefix__Group_2514" data-name="Group 2514">
            <path
              id="prefix__Path_77323"
              d="M176.5 85.333a5.834 5.834 0 1 0 5.834 5.834 5.84 5.84 0 0 0-5.834-5.834zm0 10a4.167 4.167 0 1 1 4.167-4.167 4.173 4.173 0 0 1-4.167 4.167z"
              className="prefix__cls-1"
              data-name="Path 77323"
              transform="translate(-170.666 -85.333)"
            />
          </g>
        </g>
        <g
          id="prefix__Group_2517"
          data-name="Group 2517"
          transform="translate(26.668 92)"
        >
          <g id="prefix__Group_2516" data-name="Group 2516">
            <path
              id="prefix__Path_77324"
              d="M345.5 170.667a4.167 4.167 0 1 0 4.167 4.167 4.173 4.173 0 0 0-4.167-4.167zm0 6.667a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5z"
              className="prefix__cls-1"
              data-name="Path 77324"
              transform="translate(-341.334 -170.667)"
            />
          </g>
        </g>
        <g
          id="prefix__Group_2519"
          data-name="Group 2519"
          transform="translate(3.452 92)"
        >
          <g id="prefix__Group_2518" data-name="Group 2518">
            <path
              id="prefix__Path_77325"
              d="M48.349 170.667a4.167 4.167 0 1 0 4.167 4.167 4.171 4.171 0 0 0-4.167-4.167zm0 6.667a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5z"
              className="prefix__cls-1"
              data-name="Path 77325"
              transform="translate(-44.182 -170.667)"
            />
          </g>
        </g>
        <g
          id="prefix__Group_2521"
          data-name="Group 2521"
          transform="translate(8.334 98.667)"
        >
          <g id="prefix__Group_2520" data-name="Group 2520">
            <path
              id="prefix__Path_77326"
              d="M117.5 256a10.846 10.846 0 0 0-10.834 10.834.833.833 0 0 0 1.667 0 9.167 9.167 0 1 1 18.334 0 .833.833 0 0 0 1.667 0A10.846 10.846 0 0 0 117.5 256z"
              className="prefix__cls-1"
              data-name="Path 77326"
              transform="translate(-106.666 -256)"
            />
          </g>
        </g>
        <g
          id="prefix__Group_2523"
          data-name="Group 2523"
          transform="translate(26.549 102)"
        >
          <g id="prefix__Group_2522" data-name="Group 2522">
            <path
              id="prefix__Path_77327"
              d="M344.1 298.667a7.5 7.5 0 0 0-3.885 1.083.834.834 0 0 0 .865 1.425 5.835 5.835 0 0 1 8.854 4.992.833.833 0 0 0 1.667 0 7.51 7.51 0 0 0-7.501-7.5z"
              className="prefix__cls-1"
              data-name="Path 77327"
              transform="translate(-339.813 -298.667)"
            />
          </g>
        </g>
        <g
          id="prefix__Group_2525"
          data-name="Group 2525"
          transform="translate(0 102)"
        >
          <g id="prefix__Group_2524" data-name="Group 2524">
            <path
              id="prefix__Path_77328"
              d="M11.384 299.749A7.5 7.5 0 0 0 0 306.167a.833.833 0 0 0 1.667 0 5.836 5.836 0 0 1 8.852-4.994.833.833 0 1 0 .865-1.425z"
              className="prefix__cls-1"
              data-name="Path 77328"
              transform="translate(0 -298.667)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const WorkforceNavIcon = () => {
  return (
    <svg
      fill="#ffffff"
      xmlns="http://www.w3.org/2000/svg"
      width="21.975"
      height="25.002"
      viewBox="0 0 21.975 25.002"
    >
      <g id="engineer" transform="translate(-31)">
        <g
          id="Group_2749"
          data-name="Group 2749"
          transform="translate(31 16.212)"
        >
          <g id="Group_2748" data-name="Group 2748">
            <path
              id="Path_77551"
              d="M46.382 332h-8.79A6.6 6.6 0 0 0 31 338.592v2.2h21.974v-2.2A6.6 6.6 0 0 0 46.382 332zm-9.522 7.325h-4.395v-.732a5.135 5.135 0 0 1 4.395-5.075zm8.79 0h-7.325v-2.93h7.325zm0-4.395h-7.325v-1.465h7.325zm5.86 4.395h-4.395v-5.807a5.135 5.135 0 0 1 4.395 5.075z"
              className="cls-1"
              data-name="Path 77551"
              transform="translate(-31 -332)"
            />
          </g>
        </g>
        <g id="Group_2751" data-name="Group 2751" transform="translate(34.174)">
          <g id="Group_2750" data-name="Group 2750">
            <path
              id="Path_77552"
              d="M110.161 5.713v-.83A4.889 4.889 0 0 0 105.278 0h-2.93a4.889 4.889 0 0 0-4.883 4.883v.83H96v1.465h1.465V8.4a6.348 6.348 0 0 0 12.7 0V7.178h1.465V5.713zm-7.081-4.248h1.465v4.248h-1.465zm-4.15 3.418a3.424 3.424 0 0 1 2.686-3.338v4.168H98.93zM108.7 8.4a4.883 4.883 0 1 1-9.766 0V7.178h9.766zm0-2.686h-2.686V1.545a3.424 3.424 0 0 1 2.686 3.338z"
              className="cls-1"
              data-name="Path 77552"
              transform="translate(-96)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const JobsNavIcon = () => {
  return (
    <svg
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="31"
      viewBox="0 0 33 31"
    >
      <g
        id="Group_5216"
        data-name="Group 5216"
        transform="translate(10475 23869)"
      >
        <path
          id="Exclusion_1"
          data-name="Exclusion 1"
          d="M7.5,15A7.5,7.5,0,1,1,15,7.5,7.509,7.509,0,0,1,7.5,15Zm0-13.5a6,6,0,1,0,6,6A6.006,6.006,0,0,0,7.5,1.5Z"
          transform="translate(-10457 -23853)"
        />
        <path
          id="Subtraction_1"
          data-name="Subtraction 1"
          d="M17.132,25H5.847A5.854,5.854,0,0,1,0,19.152V12.135A5.854,5.854,0,0,1,5.847,6.286H19.1a5.855,5.855,0,0,1,5.848,5.848v2.883A8.487,8.487,0,0,0,23,15.373V12.135a3.9,3.9,0,0,0-3.9-3.9H5.847a3.9,3.9,0,0,0-3.9,3.9v7.017a3.9,3.9,0,0,0,3.9,3.9H17.012C17,23.194,17,23.345,17,23.5a8.581,8.581,0,0,0,.132,1.5Zm-2.269-6.579H10.087a5.318,5.318,0,0,1-5.312-5.312.975.975,0,0,1,1.949,0,3.366,3.366,0,0,0,3.362,3.362h4.776a3.366,3.366,0,0,0,3.362-3.362.975.975,0,1,1,1.949,0A5.318,5.318,0,0,1,14.864,18.421Zm-2.381-4.533a1.223,1.223,0,1,1,.864-.359A1.21,1.21,0,0,1,12.482,13.888Zm3.649-9.551a.976.976,0,0,1-.975-.975,1.415,1.415,0,0,0-1.414-1.413H11.209A1.415,1.415,0,0,0,9.795,3.362a.975.975,0,0,1-1.949,0A3.367,3.367,0,0,1,11.209,0h2.534A3.366,3.366,0,0,1,17.1,3.362.975.975,0,0,1,16.131,4.337Z"
          transform="translate(-10475 -23869)"
        />
        <path
          id="check_14_"
          data-name="check (14)"
          d="M2.466,5.31A.329.329,0,0,1,2,5.31L.144,3.453a.493.493,0,0,1,0-.7l.232-.233a.493.493,0,0,1,.7,0L2.233,3.682,5.365.551a.493.493,0,0,1,.7,0l.232.233a.493.493,0,0,1,0,.7Zm0,0"
          transform="translate(-10452.5 -23848.387)"
        />
      </g>
    </svg>
  );
};

export const LocationsNavIcon = () => {
  return (
    <svg
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      width="20.899"
      height="25"
      viewBox="0 0 20.899 25"
    >
      <g
        id="Group_5217"
        data-name="Group 5217"
        transform="translate(10425 23866)"
      >
        <path
          id="location_1_"
          data-name="location (1)"
          d="M59.843,3.067A10.45,10.45,0,0,0,42,10.467c0,1.612.787,3.721,2.406,6.447a60.093,60.093,0,0,0,4.439,6.338,4.589,4.589,0,0,0,7.21,0h0a60.088,60.088,0,0,0,4.439-6.338c1.619-2.726,2.406-4.835,2.406-6.447a10.41,10.41,0,0,0-3.056-7.4ZM54.52,22.043a2.636,2.636,0,0,1-4.141,0c-4.084-5.184-6.426-9.4-6.426-11.576a8.5,8.5,0,1,1,16.993,0c0,2.173-2.342,6.392-6.426,11.576Z"
          transform="translate(-10467 -23866)"
        />
        <path
          id="Exclusion_2"
          data-name="Exclusion 2"
          d="M4.2,8.4A4.2,4.2,0,1,1,8.4,4.2,4.205,4.205,0,0,1,4.2,8.4Zm0-6.6A2.4,2.4,0,1,0,6.6,4.2,2.4,2.4,0,0,0,4.2,1.8Z"
          transform="translate(-10418.75 -23859.75)"
        />
      </g>
    </svg>
  );
};

export const OnBoardingNavIcon = () => {
  return (
    <svg
      fill="#ffffff"
      xmlns="http://www.w3.org/2000/svg"
      width="38.674"
      height="30.1"
      viewBox="0 0 38.674 30.1"
    >
      <g id="document" transform="translate(0.05 -56.852)">
        <g
          id="Group_2822"
          data-name="Group 2822"
          transform="translate(13.871 77.683)"
        >
          <g id="Group_2821" data-name="Group 2821" transform="translate(0 0)">
            <path
              id="Path_77563"
              data-name="Path 77563"
              d="M193.775,332.734h-8.508A1.164,1.164,0,0,0,184.1,333.9v2.609a1.164,1.164,0,0,0,1.163,1.163h8.508a1.164,1.164,0,0,0,1.163-1.163V333.9A1.164,1.164,0,0,0,193.775,332.734Zm-.332,3.44H185.6v-1.945h7.843Z"
              transform="translate(-184.105 -332.734)"
              stroke="#fff"
              strokeMiterlimit="10"
              strokeWidth="0.1"
            />
          </g>
        </g>
        <g
          id="Group_2824"
          data-name="Group 2824"
          transform="translate(0 56.902)"
        >
          <g id="Group_2823" data-name="Group 2823" transform="translate(0 0)">
            <path
              id="Path_77564"
              data-name="Path 77564"
              d="M38.2,71.221l.012-.006L32.6,60.132A2.634,2.634,0,0,0,30.24,58.68H29.175V57.65a.748.748,0,0,0-.748-.748H10.147a.748.748,0,0,0-.748.748v1.03H8.334a2.634,2.634,0,0,0-2.362,1.452L.367,71.215l.012.006A2.6,2.6,0,0,0,0,72.576V84.284A2.621,2.621,0,0,0,2.618,86.9H35.956a2.621,2.621,0,0,0,2.618-2.618V72.576A2.6,2.6,0,0,0,38.2,71.221Zm-9.021-10.88H30.24a.981.981,0,0,1,.879.541l4.59,9.076H32.589V67.165a.748.748,0,0,0-.748-.748h-.925v-4.01a.748.748,0,0,0-.748-.748h-.994Zm1.919,7.571v2.045H27.149a1.727,1.727,0,0,0-1.572,1.016L24.5,73.362a.063.063,0,0,1-.058.037H14.132a.063.063,0,0,1-.058-.037L13,70.973a1.727,1.727,0,0,0-1.572-1.016H7.481V67.912H31.094ZM10.894,58.4H27.68V61.66H10.894Zm18.527,4.758v3.263H9.153V63.155ZM7.455,60.882a.981.981,0,0,1,.879-.541H9.4V61.66H8.405a.748.748,0,0,0-.748.748v4.01H6.733a.748.748,0,0,0-.748.748v2.793H2.864Zm28.5,24.359H2.618a.958.958,0,0,1-.957-.957V72.576a.958.958,0,0,1,.957-.957h8.807a.063.063,0,0,1,.058.037l1.077,2.389a1.727,1.727,0,0,0,1.572,1.016h10.31a1.727,1.727,0,0,0,1.572-1.016l1.077-2.389h0a.063.063,0,0,1,.058-.037h8.807a.958.958,0,0,1,.957.957V84.284h0A.958.958,0,0,1,35.956,85.241Z"
              transform="translate(0 -56.902)"
              stroke="#fff"
              strokeMiterlimit="10"
              strokeWidth="0.1"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const CompanyNavIcon = () => {
  return (
    <svg
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      width="25.201"
      height="25.211"
      viewBox="0 0 25.201 25.211"
    >
      <g
        id="prefix__bank_1_"
        data-name="bank (1)"
        transform="translate(.1 .11)"
      >
        <g id="prefix__Group_2527" data-name="Group 2527">
          <g id="prefix__Group_2526" data-name="Group 2526">
            <path
              id="prefix__Path_77330"
              strokeWidth="0.2px"
              d="M24.433 10.228A.567.567 0 0 0 25 9.661V7.389a.567.567 0 0 0-.278-.488L13.608.3l-.015-.009a2.2 2.2 0 0 0-2.2.008L.278 6.9A.567.567 0 0 0 0 7.389v2.272a.567.567 0 0 0 .568.567h1.7v10.228A2.275 2.275 0 0 0 0 22.729v1.7A.568.568 0 0 0 .568 25h23.865a.568.568 0 0 0 .567-.567v-1.7a2.275 2.275 0 0 0-2.273-2.273V10.228zm-.568 12.5v1.136H1.136v-1.136a1.138 1.138 0 0 1 1.136-1.136h20.456a1.138 1.138 0 0 1 1.137 1.136zM3.409 20.456V10.228h2.273v10.228zm3.409 0V10.228h3.409v10.228zm4.546 0V10.228h2.273v10.228zm3.409 0V10.228h3.409v10.228zm4.546 0V10.228h2.273v10.228zM1.136 9.091V7.71l10.82-6.428a1.082 1.082 0 0 1 1.08 0L23.865 7.71v1.381z"
              data-name="Path 77330"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const UploadIcon = () => {
  return (
    <svg
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      width="33.879"
      height="30"
      viewBox="0 0 33.879 30"
    >
      <g id="upload_3_" data-name="upload (3)" transform="translate(0 -24)">
        <g id="Group_2786" data-name="Group 2786" transform="translate(0 24)">
          <g id="Group_2785" data-name="Group 2785">
            <circle
              id="Ellipse_690"
              cx="2.328"
              cy="2.328"
              r="2.328"
              className="cls-1"
              data-name="Ellipse 690"
              transform="translate(10.442 7.403)"
            />
            <path
              id="Path_77555"
              d="M31.875 42.3a7.168 7.168 0 0 0-4.009-1.907V28.558a4.654 4.654 0 0 0-1.325-3.233A4.517 4.517 0 0 0 23.308 24H4.558a4.654 4.654 0 0 0-3.233 1.325A4.517 4.517 0 0 0 0 28.558v19.3a4.654 4.654 0 0 0 1.325 3.233 4.517 4.517 0 0 0 3.233 1.325h18.136A6.839 6.839 0 0 0 31.875 42.3zM1.713 28.558a2.706 2.706 0 0 1 .841-1.972 2.837 2.837 0 0 1 2-.841h18.75a2.87 2.87 0 0 1 2.845 2.845v10.087l-4.784-4.784a.868.868 0 0 0-1.228 0l-7.209 7.241L8.05 36.22a.868.868 0 0 0-1.228 0l-5.109 5.172zm2.813 22.209V50.7a2.837 2.837 0 0 1-2-.841 2.95 2.95 0 0 1-.808-2v-4.01l5.722-5.754 4.881 4.881a.9.9 0 0 0 1.228 0l7.209-7.241 4.72 4.752-.291.1a3 3 0 0 0-.42.129c-.129.032-.259.1-.388.129a.968.968 0 0 0-.259.129 3 3 0 0 0-.323.162l-.485.291c-.1.065-.162.1-.259.162-.065.032-.1.065-.162.1a3.9 3.9 0 0 0-.776.679 6.839 6.839 0 0 0-2 4.849 7.107 7.107 0 0 0 .162 1.422c.032.129.065.226.1.356.1.323.194.647.323.97v.032a5.93 5.93 0 0 0 .42.776zm26.088 0a5.114 5.114 0 0 1-7.144.065c-.129-.129-.259-.291-.388-.42-.1-.1-.194-.226-.291-.323a3.07 3.07 0 0 1-.323-.55c-.065-.129-.129-.226-.194-.356a2.73 2.73 0 0 1-.162-.55c-.032-.129-.1-.291-.129-.42a5.351 5.351 0 0 1-.1-1.034 5.189 5.189 0 0 1 1.487-3.621 5 5 0 0 1 3.621-1.487 5.189 5.189 0 0 1 3.621 1.487 5.053 5.053 0 0 1 1.488 3.621 5.17 5.17 0 0 1-1.486 3.588z"
              className="cls-1"
              data-name="Path 77555"
              transform="translate(0 -24)"
            />
            <path
              id="Path_77556"
              d="M302.075 264.659a1.128 1.128 0 0 0-.291-.194.944.944 0 0 0-.291-.065h-.065a.944.944 0 0 0-.291.065.763.763 0 0 0-.291.194l-2 2a.869.869 0 1 0 1.228 1.228l.517-.517v3.556a.873.873 0 0 0 1.746 0v-3.556l.517.517a.869.869 0 0 0 1.228-1.228z"
              className="cls-1"
              data-name="Path 77556"
              transform="translate(-274.467 -244.971)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ShiftsListIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.382"
      height="30"
      viewBox="0 0 29.382 30"
    >
      <g
        id="prefix__list_3_"
        data-name="list (3)"
        transform="translate(0 -29.25)"
      >
        <g
          id="prefix__Group_1840"
          data-name="Group 1840"
          transform="translate(0 29.25)"
        >
          <path
            id="prefix__Path_74134"
            d="M3.667 36.59A3.67 3.67 0 1 0 0 32.917a3.671 3.671 0 0 0 3.667 3.673zm0-5.635A1.962 1.962 0 1 1 1.7 32.917a1.964 1.964 0 0 1 1.967-1.962z"
            className="prefix__cls-1"
            data-name="Path 74134"
            transform="translate(0 -29.25)"
          />
          <path
            id="prefix__Path_74135"
            d="M3.667 199.483A3.667 3.667 0 1 0 0 195.817a3.671 3.671 0 0 0 3.667 3.666zm0-5.628a1.962 1.962 0 1 1-1.967 1.962 1.964 1.964 0 0 1 1.967-1.962z"
            className="prefix__cls-1"
            data-name="Path 74135"
            transform="translate(0 -180.817)"
          />
          <path
            id="prefix__Path_74136"
            d="M3.667 362.383A3.667 3.667 0 1 0 0 358.716a3.671 3.671 0 0 0 3.667 3.667zm0-5.635A1.962 1.962 0 1 1 1.7 358.71a1.964 1.964 0 0 1 1.967-1.962z"
            className="prefix__cls-1"
            data-name="Path 74136"
            transform="translate(0 -332.383)"
          />
          <path
            id="prefix__Path_74137"
            d="M164.279 71.361h16.642a.879.879 0 0 0 0-1.712h-16.642a.879.879 0 0 0 0 1.712z"
            className="prefix__cls-1"
            data-name="Path 74137"
            transform="translate(-152.218 -66.839)"
          />
          <path
            id="prefix__Path_74138"
            d="M164.279 234.262h16.642a.879.879 0 0 0 0-1.712h-16.642a.879.879 0 0 0 0 1.712z"
            className="prefix__cls-1"
            data-name="Path 74138"
            transform="translate(-152.218 -218.406)"
          />
          <path
            id="prefix__Path_74139"
            d="M164.279 397.062h16.642a.879.879 0 0 0 0-1.711h-16.642a.879.879 0 0 0 0 1.711z"
            className="prefix__cls-1"
            data-name="Path 74139"
            transform="translate(-152.218 -369.879)"
          />
        </g>
      </g>
    </svg>
  );
};

export const ReportsIcon = () => {
  return (
    <svg
      fill="#ffffff"
      xmlns="http://www.w3.org/2000/svg"
      width="25.001"
      height="25.001"
      viewBox="0 0 25.001 25.001"
    >
      <path
        id="prefix__line-chart_2_"
        d="M3.613 25A3.617 3.617 0 0 1 0 21.388V12.11a3.613 3.613 0 0 1 7.227 0v9.278A3.617 3.617 0 0 1 3.613 25zm0-14.551a1.662 1.662 0 0 0-1.66 1.66v9.278a1.66 1.66 0 1 0 3.32 0V12.11a1.662 1.662 0 0 0-1.66-1.66zM12.5 25a3.617 3.617 0 0 1-3.613-3.613v-4a3.613 3.613 0 0 1 7.227 0v4A3.617 3.617 0 0 1 12.5 25zm0-9.278a1.662 1.662 0 0 0-1.66 1.66v4a1.66 1.66 0 0 0 3.32 0v-4a1.662 1.662 0 0 0-1.66-1.659zM21.388 25a3.617 3.617 0 0 1-3.613-3.613v-8.545a3.613 3.613 0 1 1 7.227 0v8.545A3.617 3.617 0 0 1 21.388 25zm0-13.819a1.662 1.662 0 0 0-1.66 1.66v8.545a1.66 1.66 0 0 0 3.32 0v-8.544a1.662 1.662 0 0 0-1.66-1.66zm-5.43-.388l5.4-5.677a.977.977 0 1 0-1.41-1.346l-5.413 5.686-.019.02a1.468 1.468 0 0 1-1.975.187l-6.2-5.633-.051-.043a3.41 3.41 0 0 0-4.406.14l-.034.032L.29 5.7a.977.977 0 0 0 1.373 1.391l1.542-1.525a1.461 1.461 0 0 1 1.85-.066l6.2 5.633.051.043a3.425 3.425 0 0 0 4.651-.384zM25 5.567V2.93A2.933 2.933 0 0 0 22.071 0h-2.637a.977.977 0 0 0 0 1.953h2.637a.978.978 0 0 1 .977.977v2.637a.977.977 0 1 0 1.953 0z"
        data-name="line-chart (2)"
      />
    </svg>
  );
};

export const FacilitiesIcon = () => {
  return (
    <svg
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      width="30.006"
      height="30"
      viewBox="0 0 30.006 30"
    >
      <g
        id="prefix__building_1_"
        data-name="building (1)"
        transform="translate(0 -.05)"
      >
        <path
          id="prefix__Path_77243"
          d="M28.482 28.292V8.069h-6.358V5.214h-2.286V1.971h-3.956V.05h-1.758v1.921h-3.956v3.243H7.882v2.855H1.524v20.223H0v1.758h30.006v-1.758zM26.724 9.827v18.465h-4.6v-4.363h2.407v-1.758h-2.407v-1.759h2.407v-1.758h-2.407V16.9h2.407v-1.762h-2.407v-1.759h2.407v-1.758h-2.407V9.827zm-14.8-6.1h6.156v1.487h-6.154zm8.44 3.243v21.32h-4.482v-2.056h-1.758v2.058H9.64V6.972zM3.282 9.827h4.6v1.794H5.515v1.758h2.367v1.758H5.515V16.9h2.367v1.758H5.515v1.758h2.367v1.758H5.515v1.758h2.367v4.363h-4.6z"
          className="prefix__cls-1"
          data-name="Path 77243"
        />
        <path
          id="prefix__Path_77244"
          d="M206.5 155.831h1.875v1.758H206.5z"
          className="prefix__cls-1"
          data-name="Path 77244"
          transform="translate(-194.398 -146.651)"
        />
        <path
          id="prefix__Path_77245"
          d="M273.5 155.831h1.875v1.758H273.5z"
          className="prefix__cls-1"
          data-name="Path 77245"
          transform="translate(-257.471 -146.651)"
        />
        <path
          id="prefix__Path_77246"
          d="M206.5 215.831h1.875v1.758H206.5z"
          className="prefix__cls-1"
          data-name="Path 77246"
          transform="translate(-194.398 -203.135)"
        />
        <path
          id="prefix__Path_77247"
          d="M273.5 215.831h1.875v1.758H273.5z"
          className="prefix__cls-1"
          data-name="Path 77247"
          transform="translate(-257.471 -203.135)"
        />
        <path
          id="prefix__Path_77248"
          d="M206.5 275.831h1.875v1.758H206.5z"
          className="prefix__cls-1"
          data-name="Path 77248"
          transform="translate(-194.398 -259.619)"
        />
        <path
          id="prefix__Path_77249"
          d="M273.5 275.831h1.875v1.758H273.5z"
          className="prefix__cls-1"
          data-name="Path 77249"
          transform="translate(-257.471 -259.619)"
        />
        <path
          id="prefix__Path_77250"
          d="M206.5 335.831h1.875v1.758H206.5z"
          className="prefix__cls-1"
          data-name="Path 77250"
          transform="translate(-194.398 -316.102)"
        />
        <path
          id="prefix__Path_77251"
          d="M273.5 335.831h1.875v1.758H273.5z"
          className="prefix__cls-1"
          data-name="Path 77251"
          transform="translate(-257.471 -316.102)"
        />
        <path
          id="prefix__Path_77252"
          d="M206.5 395.831h1.875v1.758H206.5z"
          className="prefix__cls-1"
          data-name="Path 77252"
          transform="translate(-194.398 -372.586)"
        />
        <path
          id="prefix__Path_77253"
          d="M273.5 395.831h1.875v1.758H273.5z"
          className="prefix__cls-1"
          data-name="Path 77253"
          transform="translate(-257.471 -372.586)"
        />
      </g>
    </svg>
  );
};

export const MessagesIcon = () => {
  return (
    <svg
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      width="25.2"
      height="25.278"
      viewBox="0 0 25.2 25.278"
    >
      <g
        id="prefix__comment_1_"
        data-name="comment (1)"
        transform="translate(.1 .1)"
      >
        <g id="prefix___x32__26_">
          <g id="prefix__Group_1300" data-name="Group 1300">
            <path
              id="prefix__Path_74034"
              d="M16.406 13.281H8.594a.781.781 0 0 0 0 1.563h7.812a.781.781 0 0 0 0-1.562zm1.563-4.687H7.031a.781.781 0 0 0 0 1.562h10.938a.781.781 0 1 0 0-1.562zM12.5 0C5.6 0 0 4.9 0 10.937a10.469 10.469 0 0 0 4.688 8.53V25l5.476-3.323a14.335 14.335 0 0 0 2.337.2c6.9 0 12.5-4.9 12.5-10.937S19.4 0 12.5 0zm0 20.312a12.643 12.643 0 0 1-2.641-.287l-3.678 2.212.049-3.623a9.058 9.058 0 0 1-4.668-7.676c0-5.177 4.9-9.375 10.938-9.375s10.938 4.2 10.938 9.375-4.897 9.374-10.938 9.374z"
              data-name="Path 74034"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const EmptyChatIcon = () => {
  return (
    <svg
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      width="33.847"
      height="30"
      viewBox="0 0 33.847 30"
    >
      <g>
        <path
          d="M8.774 42.25H3.752a.5.5 0 1 1 0-.992h5.023a.5.5 0 1 1 0 .992z"
          data-name="Path 77331"
          transform="translate(0 -29.099)"
        />
        <path
          d="M8.774 46.286H3.752a.5.5 0 1 1 0-.992h5.023a.5.5 0 1 1 0 .992z"
          data-name="Path 77332"
          transform="translate(0 -29.099)"
        />
        <path
          d="M19.144 50.322H3.752a.5.5 0 1 1 0-.992h15.392a.5.5 0 1 1 0 .992z"
          data-name="Path 77333"
          transform="translate(0 -29.099)"
        />
        <path
          d="M30.094 34.152H14.703a.5.5 0 1 1 0-.992h15.391a.5.5 0 0 1 0 .992z"
          data-name="Path 77334"
          transform="translate(0 -29.099)"
        />
        <path
          d="M30.094 38.187H14.703a.5.5 0 1 1 0-.992h15.391a.5.5 0 0 1 0 .992z"
          data-name="Path 77335"
          transform="translate(0 -29.099)"
        />
        <path
          d="M22.399 42.223h-7.7a.5.5 0 1 1 0-.992h7.7a.5.5 0 1 1 0 .992z"
          data-name="Path 77336"
          transform="translate(0 -29.099)"
        />
        <path
          d="M30.859 51a1.034 1.034 0 0 1-.668-.246l-4.983-4.193a1.188 1.188 0 0 0-.764-.278H14.68a3.733 3.733 0 0 1-3.729-3.729v-9.726a3.733 3.733 0 0 1 3.729-3.729h15.438a3.733 3.733 0 0 1 3.729 3.729v9.727a3.742 3.742 0 0 1-3.058 3.668l1.062 3.43A1.042 1.042 0 0 1 30.859 51zM14.681 30.09a2.74 2.74 0 0 0-2.737 2.737v9.727a2.74 2.74 0 0 0 2.737 2.737h9.763a2.181 2.181 0 0 1 1.4.511L30.829 50a.047.047 0 0 0 .075-.05l-1.111-3.59a.843.843 0 0 1 .095-.7.852.852 0 0 1 .6-.386 2.745 2.745 0 0 0 2.364-2.712v-9.734a2.74 2.74 0 0 0-2.737-2.737z"
          data-name="Path 77337"
          transform="translate(0 -29.099)"
        />
        <path
          d="M2.989 59.094A1.042 1.042 0 0 1 2 57.751l1.062-3.43A3.739 3.739 0 0 1 0 50.653v-9.727a3.733 3.733 0 0 1 3.729-3.732h5.734a.5.5 0 0 1 0 .992H3.729a2.74 2.74 0 0 0-2.737 2.737v9.727a2.743 2.743 0 0 0 2.722 2.744.5.5 0 0 1 .471.642l-1.242 4.008a.047.047 0 0 0 .075.05L7.765 54.1a3.027 3.027 0 0 1 1.946-.71h9.455a2.74 2.74 0 0 0 2.737-2.737v-2.859a.5.5 0 0 1 .992 0v2.863a3.733 3.733 0 0 1-3.729 3.729H9.711a2.034 2.034 0 0 0-1.307.477l-4.747 3.994a1.035 1.035 0 0 1-.668.246z"
          data-name="Path 77338"
          transform="translate(0 -29.099)"
        />
      </g>
    </svg>
  );
};

export const EmployersIcon = () => {
  return (
    <svg
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      width="39.374"
      height="25"
      viewBox="0 0 39.374 25"
    >
      <g
        id="prefix__group_6_"
        data-name="group (6)"
        transform="translate(0 -92.25)"
      >
        <g
          id="prefix__Group_1909"
          data-name="Group 1909"
          transform="translate(0 92.25)"
        >
          <path
            id="prefix__Path_74202"
            d="M34.053 103.25a4.5 4.5 0 1 0-5.157 0 7.789 7.789 0 0 0-2.657 1.558 10.078 10.078 0 0 0-3.646-1.987 5.695 5.695 0 1 0-5.89 0 10.162 10.162 0 0 0-3.607 1.963 7.852 7.852 0 0 0-2.625-1.527 4.5 4.5 0 1 0-5.157 0A7.89 7.89 0 0 0 0 110.714v.514a.034.034 0 0 0 .031.031h9.528a10.478 10.478 0 0 0-.086 1.317v.53a4.143 4.143 0 0 0 4.145 4.145h12.075a4.143 4.143 0 0 0 4.145-4.145v-.53a10.478 10.478 0 0 0-.086-1.317h9.59a.034.034 0 0 0 .031-.031v-.514a7.921 7.921 0 0 0-5.32-7.464zm-5.827-3.685a3.249 3.249 0 1 1 3.311 3.249h-.125a3.244 3.244 0 0 1-3.187-3.249zm-13.041-1.62a4.448 4.448 0 1 1 4.706 4.441h-.514a4.455 4.455 0 0 1-4.193-4.441zM4.62 99.565a3.249 3.249 0 1 1 3.311 3.249h-.125a3.249 3.249 0 0 1-3.186-3.249zM9.777 110H1.262a6.656 6.656 0 0 1 6.56-5.944h.093a6.587 6.587 0 0 1 4.246 1.581A10.229 10.229 0 0 0 9.777 110zm18.8 3.1a2.9 2.9 0 0 1-2.9 2.9H13.6a2.9 2.9 0 0 1-2.9-2.9v-.53a8.949 8.949 0 0 1 8.671-8.936c.086.008.179.008.265.008s.179 0 .265-.008a8.949 8.949 0 0 1 8.671 8.936zm.923-3.1a10.2 10.2 0 0 0-2.361-4.332 6.619 6.619 0 0 1 4.285-1.613h.093A6.656 6.656 0 0 1 38.08 110z"
            data-name="Path 74202"
            transform="translate(0 -92.25)"
          />
        </g>
      </g>
    </svg>
  );
};

export const LocationsIcon = () => {
  return (
    <svg
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      id="prefix__placeholder_3_"
      width="20.052"
      height="25"
      data-name="placeholder (3)"
      viewBox="0 0 20.052 25"
    >
      <g id="prefix__Group_8" data-name="Group 8">
        <path
          id="prefix__Path_8"
          d="M57.221 0A10.034 10.034 0 0 0 47.2 10.021a9.863 9.863 0 0 0 .178 1.882c.005.037.026.147.068.335a9.869 9.869 0 0 0 .671 1.976c1.08 2.542 3.454 6.447 8.664 10.629a.71.71 0 0 0 .891 0c5.2-4.182 7.584-8.087 8.664-10.629a9.758 9.758 0 0 0 .671-1.976c.042-.189.063-.3.068-.335a10.308 10.308 0 0 0 .178-1.882A10.05 10.05 0 0 0 57.221 0zm8.449 11.656c0 .01-.005.021-.005.031l-.047.225v.01a8.321 8.321 0 0 1-.582 1.709c-.005.005-.005.016-.01.021-.98 2.322-3.129 5.865-7.8 9.727-4.675-3.863-6.824-7.406-7.8-9.727-.005-.005-.005-.016-.01-.021a8.875 8.875 0 0 1-.582-1.709v-.01c-.031-.121-.042-.2-.047-.225 0-.01-.005-.021-.005-.037a8.605 8.605 0 1 1 16.9.005z"
          className="prefix__cls-1"
          data-name="Path 8"
          transform="translate(-47.2)"
        />
        <path
          id="prefix__Path_9"
          d="M120.95 71.9a3.95 3.95 0 1 0 3.95 3.95 3.956 3.956 0 0 0-3.95-3.95zm0 7.021a3.071 3.071 0 1 1 3.071-3.071 3.075 3.075 0 0 1-3.071 3.071z"
          className="prefix__cls-1"
          data-name="Path 9"
          transform="translate(-110.929 -65.719)"
        />
      </g>
    </svg>
  );
};

export const BadgesIcon = () => {
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 20 30.3">
      <path className="st0" d="M20,10c0-5.5-4.5-10-10-10S0,4.5,0,10c0,3.3,1.6,6.2,4.1,8L2.6,29.1c-0.1,0.4,0.1,0.8,0.4,1
	c0.2,0.1,0.4,0.2,0.5,0.2c0.2,0,0.4,0,0.5-0.1l5.9-3.5l5.9,3.5c0.3,0.2,0.7,0.2,1.1,0c0.3-0.2,0.5-0.6,0.4-1L15.9,18
	C18.4,16.2,20,13.3,20,10z M2,10c0-4.4,3.6-8,8-8s8,3.6,8,8s-3.6,8-8,8S2,14.4,2,10z M15.2,27.4l-4.6-2.8c-0.3-0.2-0.7-0.2-1,0
	l-4.6,2.8l1.1-8.2C7.2,19.7,8.5,20,10,20c1.5,0,2.8-0.3,4.1-0.9L15.2,27.4z"/>
    </svg>
  );
};

export const DefaultBadgeIcon = () => {
  return (
    <svg version="1.1" id="shipping-and-delivery" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 18.3 17.3" >
      <path id="Union_13" className="st0" d="M13.8,16.1c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2c0,0.7-0.6,1.2-1.2,1.2S13.8,16.8,13.8,16.1z
	 M4.4,16.1c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2c0,0.7-0.6,1.2-1.2,1.2S4.4,16.8,4.4,16.1C4.4,16.1,4.4,16.1,4.4,16.1z M17.4,15.6
	c-0.2-1.3-1.5-2.1-2.7-1.8c-0.9,0.2-1.7,0.9-1.8,1.8h0V7.2h0.9c1.3,0,2.5,0.7,3.1,1.8h-1.7c-0.8,0-1.6,0.6-1.6,1.4v2
	c0,0.3,0.2,0.5,0.5,0.5c0,0,0,0,0,0h4.3v2.2c0,0.3-0.2,0.5-0.5,0.5c0,0,0,0,0,0L17.4,15.6z M7.9,15.6c-0.2-1.3-1.5-2.1-2.7-1.8
	c-0.9,0.2-1.6,0.9-1.8,1.8h-1c-0.3,0-0.5-0.2-0.5-0.5l0,0v-3.2H0.6c-0.3,0-0.5-0.2-0.6-0.5c0-0.3,0.2-0.5,0.5-0.6c0,0,0,0,0,0h1.2
	v1.1h2.6c0.3,0,0.5-0.2,0.6-0.5c0-0.3-0.2-0.5-0.5-0.6c0,0,0,0,0,0H1.8v-1H1.3C1,9.8,0.8,9.6,0.7,9.3C0.7,9,1,8.8,1.3,8.8
	c0,0,0,0,0,0h0.5v1.1h4.3c0.3,0,0.5-0.2,0.6-0.5c0-0.3-0.2-0.5-0.5-0.6c0,0,0,0,0,0H1.8V7.7H0.6C0.3,7.7,0,7.5,0,7.2
	c0-0.3,0.2-0.5,0.5-0.6c0,0,0,0,0,0h1.2v1.1h1.9c0.3,0,0.5-0.2,0.6-0.5c0-0.3-0.2-0.5-0.5-0.6c0,0,0,0,0,0H1.8V6.1
	c0-0.3,0.2-0.5,0.5-0.5h0h8.5c0.5,0,0.9,0.4,0.9,0.9v9.2L7.9,15.6z M14.5,11.9v-1.4c0-0.2,0.3-0.4,0.5-0.4h2.2l0.8,1.8L14.5,11.9z
	 M12.6,3.8V2.5c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4c0,0,0,0,0,0v1.2c0,0.1-0.2,0.3-0.4,0.3C11.2,4,11,3.9,11,3.8V0.3
	C11,0.1,11.2,0,11.4,0c0.2,0,0.4,0.1,0.4,0.3v1.6c0.1-0.3,0.4-0.4,0.7-0.4c0.6,0.1,1,0.6,0.9,1.1v1.2C13.4,3.9,13.2,4,13,4
	C12.8,4,12.6,3.9,12.6,3.8z M8.9,3.8V3.2H7.6c-0.1,0-0.3-0.1-0.3-0.3c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2l1.2-2.4C8.7,0.2,8.8,0.1,9,0.1
	c0.1,0,0.4,0.1,0.4,0.3c0,0,0,0.1,0,0.1L8.4,2.4h0.5V2c0-0.2,0.2-0.3,0.4-0.3S9.7,1.9,9.7,2v0.4H10c0.2,0,0.3,0.2,0.3,0.4
	S10.1,3.2,10,3.2H9.7v0.6C9.7,3.9,9.5,4,9.3,4S8.9,3.9,8.9,3.8L8.9,3.8z M4.7,4C4.5,4,4.3,3.9,4.3,3.8V3.2c0-0.8,1.7-1.3,1.7-2
	C6,1,5.8,0.9,5.6,0.8c0,0,0,0,0,0C5.4,0.8,5.2,1,5.2,1.2c0,0,0,0,0,0.1c0,0.2-0.2,0.3-0.4,0.3c-0.2,0-0.4-0.1-0.4-0.4
	c0-0.6,0.6-1.1,1.2-1c0,0,0,0,0,0C6.2,0,6.8,0.5,6.8,1.2c0,0,0,0,0,0c0,1.2-1.7,1.5-1.7,2v0h1.4c0.1,0,0.3,0.2,0.3,0.4S6.7,4,6.6,4
	L4.7,4z"/>
    </svg>
  );
};


export const CompanyIcon = () => {
  return (
    <svg
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      width="24.842"
      height="25.304"
      viewBox="0 0 24.842 25.304"
    >
      <g id="prefix__surface1" transform="translate(.083 .153)">
        <path
          id="prefix__Path_74123"
          d="M.549 6.907a1.011 1.011 0 0 0-.016.15v1.028a1.02 1.02 0 0 0 .662.952v1.513a.951.951 0 0 0 .905.95v8.742a.952.952 0 0 0-.906.947v1.509a1.031 1.031 0 0 0-.662.961v1.006a.34.34 0 0 0 .34.34H23.79a.34.34 0 0 0 .34-.34v-1.01a1.031 1.031 0 0 0-.661-.961v-1.517a.951.951 0 0 0-.906-.947V11.5a.951.951 0 0 0 .906-.947V9.036a1.02 1.02 0 0 0 .661-.952V7.063a.99.99 0 0 0-.016-.15.338.338 0 0 0 .274-.618L12.488.04a.34.34 0 0 0-.317 0L.27 6.288a.34.34 0 0 0 .279.618zm1.325 2.718V9.1h3.919v.519zM10.6 11.5v8.74a.952.952 0 0 0-.906.947v1.445H6.468v-1.446a.952.952 0 0 0-.906-.947V11.5a.951.951 0 0 0 .906-.947V9.1H9.69v1.446a.952.952 0 0 0 .906.949zm-.227-1.874V9.1h3.919v.519zM19.1 11.5v8.74a.952.952 0 0 0-.906.947v1.445h-3.226v-1.446a.952.952 0 0 0-.906-.947V11.5a.951.951 0 0 0 .906-.947V9.1h3.222v1.446a.952.952 0 0 0 .906.949zm-.227-1.874V9.1h3.919v.519zm3.919 12.487v.519h-3.923v-.519zm-8.5 0v.519H10.37v-.519zm-3.356-11.289h-.294a.272.272 0 0 1-.272-.272V10.3h3.919v.247a.272.272 0 0 1-.272.272zm2.449.68v8.731h-2.109V11.5zm-2.449 9.411h3.081a.272.272 0 0 1 .272.272v.247H10.37v-.247a.272.272 0 0 1 .272-.272zm-5.147 1.2v.519h-3.92v-.519zm-3.92-11.556V10.3h3.92v.247a.272.272 0 0 1-.272.272H2.135a.272.272 0 0 1-.265-.274zm3.013.951v8.724H2.776V11.5zm-3.013 9.683a.272.272 0 0 1 .272-.272h3.376a.272.272 0 0 1 .272.272v.247h-3.92zm21.581 2.476v.666H1.208v-.666a.351.351 0 0 1 .351-.351H23.1a.351.351 0 0 1 .351.344zm-.661-2.476v.247h-3.92v-.247a.272.272 0 0 1 .272-.272h3.382a.272.272 0 0 1 .265.265zm-3.013-.952V11.5h2.109v8.731zm3.013-9.683a.272.272 0 0 1-.272.272h-3.373a.272.272 0 0 1-.272-.272V10.3h3.919zM12.329.72l10.12 5.319H2.209zM1.208 7.063a.34.34 0 0 1 .34-.34h21.563a.34.34 0 0 1 .34.34v1.029a.34.34 0 0 1-.34.34H1.548a.34.34 0 0 1-.34-.34zm0 0"
          data-name="Path 74123"
        />
      </g>
    </svg>
  );
};

export const ContactUserIcon = () => {
  return (
    <svg
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      width="15.891"
      height="20.5"
      viewBox="0 0 15.891 20.5"
    >
      <g
        id="prefix__person_2_"
        data-name="person (2)"
        transform="translate(-58.75 .25)"
      >
        <g
          id="prefix__Group_2503"
          data-name="Group 2503"
          transform="translate(59 12.109)"
        >
          <path
            id="prefix__Path_77317"
            d="M73.609 317.891a.781.781 0 0 1-.781-.781 5.553 5.553 0 0 0-5.547-5.547h-1.172a5.553 5.553 0 0 0-5.547 5.547.781.781 0 1 1-1.562 0 7.117 7.117 0 0 1 7.109-7.11h1.172a7.117 7.117 0 0 1 7.109 7.109.781.781 0 0 1-.781.782z"
            className="prefix__cls-1"
            data-name="Path 77317"
            transform="translate(-59 -310)"
          />
        </g>
        <g
          id="prefix__Group_2504"
          data-name="Group 2504"
          transform="translate(61.344)"
        >
          <path
            id="prefix__Path_77318"
            d="M124.273 10.547a5.273 5.273 0 1 1 5.273-5.273 5.279 5.279 0 0 1-5.273 5.273zm0-8.984a3.711 3.711 0 1 0 3.711 3.711 3.715 3.715 0 0 0-3.711-3.712z"
            className="prefix__cls-1"
            data-name="Path 77318"
            transform="translate(-119)"
          />
        </g>
      </g>
    </svg>
  );
};

export const ContactEmailIcon = () => {
  return (
    <svg
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      width="20.003"
      height="20"
      viewBox="0 0 20.003 20"
    >
      <path
        id="prefix__invite"
        d="M18.158 5.047L12.845.994a4.7 4.7 0 0 0-5.686 0L1.845 5.047A4.715 4.715 0 0 0 0 8.774v6.574a4.694 4.694 0 0 0 4.688 4.688h10.627A4.694 4.694 0 0 0 20 15.348V8.774a4.715 4.715 0 0 0-1.845-3.728zm.282 10.3a3.129 3.129 0 0 1-3.125 3.125H4.688a3.129 3.129 0 0 1-3.125-3.125V8.774a3.143 3.143 0 0 1 1.23-2.485l5.313-4.052a3.133 3.133 0 0 1 3.791 0l5.313 4.052a3.143 3.143 0 0 1 1.23 2.485zm-1.684-5.708a.781.781 0 0 1-.147 1.1l-3.764 2.872a4.7 4.7 0 0 1-5.686 0l-3.726-2.846a.781.781 0 1 1 .948-1.243l3.725 2.841a3.133 3.133 0 0 0 3.791 0l3.764-2.872a.781.781 0 0 1 1.1.147z"
        transform="translate(0 -.036)"
      />
    </svg>
  );
};

export const ContactPhoneIcon = () => {
  return (
    <svg
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g
        id="prefix__phone-call_2_"
        data-name="phone-call (2)"
        transform="translate(0 -.002)"
      >
        <g
          id="prefix__Group_2432"
          data-name="Group 2432"
          transform="translate(0 .002)"
        >
          <path
            id="prefix__Path_77230"
            d="M20 16.117a2.958 2.958 0 0 0-.907-2.033 7.266 7.266 0 0 0-2.877-1.911 3.22 3.22 0 0 0-3.306.938l-1.056 1.048a15.829 15.829 0 0 1-3.331-2.576l-.1-.1a15.831 15.831 0 0 1-2.576-3.33L6.886 7.1a3.22 3.22 0 0 0 .938-3.306A7.267 7.267 0 0 0 5.918.911 2.973 2.973 0 0 0 1.792.762l-.022.02-.03.029A6.339 6.339 0 0 0 0 5.454c.016 3.212 1.781 6.885 4.722 9.825a21.336 21.336 0 0 0 5.359 3.682c.342.263.961-1.172.619-1.435-1.379-.407-4.367-2.845-4.873-3.352-2.656-2.656-4.25-5.919-4.264-8.728A4.827 4.827 0 0 1 2.83 1.93l.006-.005A1.405 1.405 0 0 1 4.793 2c2.023 2.1 1.876 3.088.982 4L4.327 7.459a.781.781 0 0 0-.159.868 15.786 15.786 0 0 0 3.141 4.263l.1.1a15.784 15.784 0 0 0 4.263 3.141.781.781 0 0 0 .868-.159L14 14.226c.917-.894 1.907-1.04 4 .982a1.405 1.405 0 0 1 .071 1.957l-.006.006a4.812 4.812 0 0 1-3.481 1.267h-.036a10.13 10.13 0 0 1-3.855-.913c.361.879-1.015 1.264-.619 1.435A11.525 11.525 0 0 0 14.548 20h.044a6.325 6.325 0 0 0 4.6-1.739l.029-.03.02-.023A2.958 2.958 0 0 0 20 16.117z"
            data-name="Path 77230"
            transform="translate(0 -.002)"
          />
        </g>
      </g>
    </svg>
  );
};

export const ContactAddressIcon = () => {
  return (
    <svg
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      width="16.242"
      height="20.2"
      viewBox="0 0 16.242 20.2"
    >
      <g
        id="prefix__placeholder_5_"
        data-name="placeholder (5)"
        transform="translate(-47.1 .1)"
      >
        <g
          id="prefix__Group_1939"
          data-name="Group 1939"
          transform="translate(47.2)"
        >
          <path
            id="prefix__Path_77143"
            d="M55.217 0A8.027 8.027 0 0 0 47.2 8.017a7.891 7.891 0 0 0 .143 1.505c0 .029.021.117.055.268a7.9 7.9 0 0 0 .537 1.581 22.473 22.473 0 0 0 6.931 8.5.568.568 0 0 0 .713 0 22.516 22.516 0 0 0 6.931-8.5 7.807 7.807 0 0 0 .537-1.581c.034-.151.05-.239.055-.268a8.245 8.245 0 0 0 .143-1.505A8.04 8.04 0 0 0 55.217 0zm6.759 9.325v.025c0 .008-.017.084-.038.18v.008a6.656 6.656 0 0 1-.465 1.367s0 .013-.008.017a20.973 20.973 0 0 1-6.248 7.778 20.973 20.973 0 0 1-6.243-7.782s0-.013-.008-.017a7.1 7.1 0 0 1-.466-1.362V9.53c-.025-.1-.034-.159-.038-.18s0-.017 0-.029a6.884 6.884 0 1 1 13.518 0z"
            data-name="Path 77143"
            transform="translate(-47.2)"
          />
          <path
            id="prefix__Path_77144"
            d="M120.548 71.9a3.548 3.548 0 1 0 3.548 3.548 3.554 3.554 0 0 0-3.548-3.548zm0 6.307a2.759 2.759 0 1 1 2.759-2.759 2.762 2.762 0 0 1-2.759 2.759z"
            data-name="Path 77144"
            transform="translate(-112.531 -67.343)"
          />
        </g>
      </g>
    </svg>
  );
};

export const ExpandIcon = () => {
  return (
    <svg
      fill="white"
      className="expand-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="7.381"
      viewBox="0 0 10 7.381"
    >
      <path
        id="play-button_7_"
        d="M7.278 4.8L.373.042A.238.238 0 0 0 0 .238v9.524a.238.238 0 0 0 .373.2L7.278 5.2a.238.238 0 0 0 0-.392z"
        data-name="play-button (7)"
        transform="rotate(90 5 5)"
      />
    </svg>
  );
};

export const WorkersTaskIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.591"
      height="20.2"
      viewBox="0 0 15.591 20.2"
    >
      <g
        id="prefix__person_2_"
        data-name="person (2)"
        transform="translate(-58.9 .1)"
      >
        <g
          id="prefix__Group_2503"
          data-name="Group 2503"
          transform="translate(59 12.109)"
        >
          <path
            id="prefix__Path_77317"
            d="M73.609 317.891a.781.781 0 0 1-.781-.781 5.553 5.553 0 0 0-5.547-5.547h-1.172a5.553 5.553 0 0 0-5.547 5.547.781.781 0 0 1-1.562 0 7.117 7.117 0 0 1 7.109-7.11h1.172a7.117 7.117 0 0 1 7.109 7.109.781.781 0 0 1-.781.782z"
            className="prefix__cls-1"
            data-name="Path 77317"
            transform="translate(-59 -310)"
          />
        </g>
        <g
          id="prefix__Group_2504"
          data-name="Group 2504"
          transform="translate(61.344)"
        >
          <path
            id="prefix__Path_77318"
            d="M124.273 10.547a5.273 5.273 0 1 1 5.273-5.273 5.279 5.279 0 0 1-5.273 5.273zm0-8.984a3.711 3.711 0 1 0 3.711 3.711 3.715 3.715 0 0 0-3.711-3.711z"
            className="prefix__cls-1"
            data-name="Path 77318"
            transform="translate(-119)"
          />
        </g>
      </g>
    </svg>
  );
};

export const TeamTaskIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="21"
      viewBox="0 0 25 21"
    >
      <g
        id="Group_2514"
        data-name="Group 2514"
        transform="translate(-106.166 -84.833)"
      >
        <g
          id="Group_2506"
          data-name="Group 2506"
          transform="translate(110.666 85.333)"
        >
          <g id="Group_2505" data-name="Group 2505" transform="translate(0 0)">
            <path
              id="Path_77319"
              data-name="Path 77319"
              d="M175.333,85.333A4.667,4.667,0,1,0,180,90,4.672,4.672,0,0,0,175.333,85.333Zm0,8A3.333,3.333,0,1,1,178.666,90,3.338,3.338,0,0,1,175.333,93.333Z"
              transform="translate(-170.666 -85.333)"
              fill="#6f1989"
              stroke="rgba(0,0,0,0)"
              strokeWidth="1"
            />
          </g>
        </g>
        <g
          id="Group_2508"
          data-name="Group 2508"
          transform="translate(121.333 90.666)"
        >
          <g id="Group_2507" data-name="Group 2507" transform="translate(0 0)">
            <path
              id="Path_77320"
              data-name="Path 77320"
              d="M344.667,170.667A3.333,3.333,0,1,0,348,174,3.338,3.338,0,0,0,344.667,170.667Zm0,5.333a2,2,0,1,1,2-2A2,2,0,0,1,344.667,176Z"
              transform="translate(-341.334 -170.667)"
              fill="#6f1989"
              stroke="rgba(0,0,0,0)"
              strokeWidth="1"
            />
          </g>
        </g>
        <g
          id="Group_2510"
          data-name="Group 2510"
          transform="translate(106.666 96)"
        >
          <g id="Group_2509" data-name="Group 2509" transform="translate(0 0)">
            <path
              id="Path_77321"
              data-name="Path 77321"
              d="M115.333,256a8.677,8.677,0,0,0-8.667,8.667.667.667,0,0,0,1.333,0,7.333,7.333,0,1,1,14.667,0,.667.667,0,0,0,1.333,0A8.677,8.677,0,0,0,115.333,256Z"
              transform="translate(-106.666 -256)"
              fill="#6f1989"
              stroke="rgba(0,0,0,0)"
              strokeWidth="1"
            />
          </g>
        </g>
        <g
          id="Group_2512"
          data-name="Group 2512"
          transform="translate(121.238 98.666)"
        >
          <g id="Group_2511" data-name="Group 2511" transform="translate(0)">
            <path
              id="Path_77322"
              data-name="Path 77322"
              d="M343.241,298.667a6,6,0,0,0-3.108.867.667.667,0,1,0,.692,1.14,4.668,4.668,0,0,1,7.083,3.993.667.667,0,1,0,1.333,0A6.007,6.007,0,0,0,343.241,298.667Z"
              transform="translate(-339.813 -298.667)"
              fill="#6f1989"
              stroke="rgba(0,0,0,0)"
              strokeWidth="1"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ShiftRequestsIcon = () => {
  return (
    <svg
      version="1.1"
      id="Shift_Request"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 25 25"
    >
      <g>
        <path
          d="M11.7,7.9c1.1-1.2,1-3-0.2-4.1c-1.2-1.1-3-1-4.1,0.2c-1,1.1-1,2.9,0,4C5.8,8.7,4.9,10.3,4.9,12v0.5c0,0.4,0.3,0.7,0.7,0.7
		h7.8c0.4,0,0.7-0.3,0.7-0.7V12C14.2,10.3,13.2,8.7,11.7,7.9z M9.5,4.4L9.5,4.4c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5
		c-0.8,0-1.5-0.7-1.5-1.5C8.1,5.1,8.7,4.4,9.5,4.4z M6.4,11.8C6.5,10,8,8.7,9.8,8.8c1.6,0.1,2.8,1.4,2.9,2.9H6.4z"
        />
        <path
          d="M23.3,15.2h-1.2v-0.7c0-0.9-0.8-1.7-1.7-1.7H19V3.7c0-2-1.6-3.7-3.7-3.7H0.7C0.3,0,0,0.3,0,0.7v23.5C0,24.7,0.3,25,0.7,25
		h22.6c0.9,0,1.7-0.8,1.7-1.7v-6.3C25,16,24.2,15.2,23.3,15.2z M20.4,14.3c0.1,0,0.2,0.1,0.2,0.2v0.7h-3.4v-0.7
		c0-0.1,0.1-0.2,0.2-0.2L20.4,14.3z M16.1,1.6c0.6,0.2,1.1,0.7,1.3,1.3h-1.3V1.6z M12.8,16.9v6.3c0,0.1,0,0.2,0,0.2H1.5V1.5h13.2
		v2.2c0,0.4,0.3,0.7,0.7,0.7h2.2v8.4h-0.1c-0.9,0-1.7,0.8-1.7,1.7v0.7h-1.2C13.6,15.2,12.8,16,12.8,16.9z M23.3,23.5h-8.8
		c-0.1,0-0.2-0.1-0.2-0.2v-3.7h1.5v0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7v-0.7h3.4v0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7
		v-0.7h1.5l0,3.7C23.5,23.4,23.4,23.5,23.3,23.5z M14.3,18.2v-1.2c0-0.1,0.1-0.2,0.2-0.2h8.8c0.1,0,0.2,0.1,0.2,0.2l0,1.2H14.3z"
        />
        <path d="M4.6,14.7h-1c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7h1c0.4,0,0.7-0.3,0.7-0.7C5.4,15,5,14.7,4.6,14.7z" />
        <path d="M11,14.7H7.6c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7H11c0.4,0,0.7-0.3,0.7-0.7C11.7,15,11.4,14.7,11,14.7z" />
        <path d="M4.6,17.6h-1c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7h1c0.4,0,0.7-0.3,0.7-0.7S5,17.6,4.6,17.6z" />
        <path d="M11,17.6H7.6c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7H11c0.4,0,0.7-0.3,0.7-0.7S11.4,17.6,11,17.6z" />
        <path d="M4.6,20.6h-1c-0.4,0-0.7,0.3-0.7,0.7S3.3,22,3.7,22h1c0.4,0,0.7-0.3,0.7-0.7S5,20.6,4.6,20.6z" />
        <path d="M11,20.6H7.6c-0.4,0-0.7,0.3-0.7,0.7S7.2,22,7.6,22H11c0.4,0,0.7-0.3,0.7-0.7S11.4,20.6,11,20.6z" />
      </g>
    </svg>
  );
};

export const DraftShiftRequestsIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.3931 12.0661V5.70414H16.7496V2.79795H14.9111V0H3.58817V3.65716H0.0280762V17.2853H11.8245C12.0125 19.9165 14.2131 22 16.8915 22C19.6928 22 21.9717 19.721 21.9717 16.9198C21.9717 14.641 20.4636 12.708 18.3931 12.0661V12.0661ZM15.458 5.70414H7.37483V4.08955H15.458V5.70414ZM13.6195 1.2916V2.798H6.08323V5.27291L4.87976 3.68053V1.2916H13.6195ZM1.31963 4.94871H4.21925L5.76634 6.99574H17.1015V11.8442C17.0318 11.8414 16.9618 11.8395 16.8915 11.8395C14.4065 11.8395 12.3327 13.6331 11.8961 15.9937H1.31963V4.94871ZM16.8915 20.7084C14.8025 20.7084 13.1029 19.0088 13.1029 16.9198C13.1029 14.8307 14.8025 13.1311 16.8915 13.1311C18.9806 13.1311 20.6801 14.8307 20.6801 16.9198C20.6801 19.0088 18.9806 20.7084 16.8915 20.7084Z" />
      <path d="M18.0364 17.8454L16.7273 16.8636V14.8636C16.7273 14.6625 16.5647 14.5 16.3636 14.5C16.1625 14.5 16 14.6625 16 14.8636V17.0455C16 17.16 16.0538 17.268 16.1455 17.3364L17.6 18.4273C17.6654 18.4764 17.7418 18.5 17.8178 18.5C17.9287 18.5 18.0378 18.4502 18.1091 18.3542C18.2298 18.1938 18.1971 17.9658 18.0364 17.8454Z" stroke="black" strokeWidth="0.3" />
    </svg>

  );
};

export const ShiftsIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 27.1 25"
    >
      <g>
        <path d="M4.6,14.7h-1c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7h1h0c0.4,0,0.7-0.3,0.7-0.7S5,14.7,4.6,14.7z" />
        <path d="M7.6,19.1H11c0.4,0,0.7-0.3,0.7-0.7s-0.3-0.7-0.7-0.7H7.6c-0.4,0-0.7,0.3-0.7,0.7S7.2,19.1,7.6,19.1z" />
        <path d="M4.6,20.6h-1c-0.4,0-0.7,0.3-0.7,0.7S3.3,22,3.7,22h1h0c0.4,0,0.7-0.3,0.7-0.7S5,20.6,4.6,20.6z" />
        <path d="M7.6,16.2H11c0.4,0,0.7-0.3,0.7-0.7s-0.3-0.7-0.7-0.7H7.6c-0.4,0-0.7,0.3-0.7,0.7S7.2,16.2,7.6,16.2z" />
        <path d="M7.6,22H11c0.4,0,0.7-0.3,0.7-0.7s-0.3-0.7-0.7-0.7H7.6c-0.4,0-0.7,0.3-0.7,0.7S7.2,22,7.6,22z" />
        <path
          d="M14.2,12.5V12c0-0.9-0.2-1.7-0.7-2.4c-0.4-0.7-1.1-1.3-1.8-1.7c1-1.1,1-2.9,0-4c-1.1-1.2-3-1.3-4.1-0.2s-1.3,3-0.2,4.1
		C5.8,8.7,4.9,10.3,4.9,12v0.5c0,0.4,0.3,0.7,0.7,0.7h7.8l0,0C13.8,13.2,14.2,12.9,14.2,12.5z M9.5,4.4c0.8,0,1.5,0.7,1.5,1.5
		c0,0.8-0.7,1.5-1.5,1.5S8.1,6.7,8.1,5.9S8.7,4.4,9.5,4.4z M6.4,11.8c0.1-1.7,1.5-2.9,3.2-2.9c1.2,0,2.3,0.7,2.9,1.8
		c0.2,0.4,0.3,0.7,0.3,1.1H6.4z"
        />
        <path
          d="M1.5,1.5h13.2v2.2c0,0.4,0.3,0.7,0.7,0.7h2.2v7.1H19V3.7c0-2-1.6-3.7-3.7-3.7H0.7C0.3,0,0,0.3,0,0.7v23.5
		C0,24.7,0.3,25,0.7,25h11.8v-1.5H1.5V1.5z M16.1,1.6c0.6,0.2,1.1,0.7,1.3,1.3h-1.3V1.6z"
        />
        <path d="M4.6,17.6h-1c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7h1h0c0.4,0,0.7-0.3,0.7-0.7S5,17.6,4.6,17.6z" />
        <path
          d="M24.6,12.9h-8.4h0c-1.4,0-2.5,1.1-2.5,2.5v9c0,0.4,0.3,0.7,0.7,0.7c0.2,0,0.3-0.1,0.4-0.2l2.2-1.8h7.5c0,0,0,0,0,0
		c0.7,0,1.3-0.3,1.7-0.7c0.5-0.5,0.7-1.1,0.7-1.7v-5.2C27.1,14,26,12.9,24.6,12.9z M25.8,20.5c0,0.6-0.5,1.1-1.1,1.1h-7.8
		c-0.2,0-0.3,0.1-0.4,0.2l-1.3,1.1v-7.5c0-0.6,0.5-1.1,1.1-1.1h8.4h0c0.6,0,1.1,0.5,1.1,1.1L25.8,20.5z"
        />
        <path
          d="M18,15.9C18,15.9,18,15.9,18,15.9h-1.2c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h0.7v1.9c0,0.2-0.1,0.3-0.3,0.3
		s-0.3-0.1-0.3-0.3c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3v-2.4c0-0.1,0-0.2-0.1-0.3
		C18.3,15.9,18.1,15.9,18,15.9z"
        />
        <path
          d="M20.3,15.9c-0.8,0-1.5,0.7-1.5,1.5v1.2c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5v-1.2C21.7,16.5,21.1,15.9,20.3,15.9z
		 M20.8,18.5c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5v-1.2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V18.5z"
        />
        <path
          d="M24.6,16.2c-0.2-0.2-0.5-0.3-0.9-0.3c0,0,0,0,0,0h-1.2c-0.3,0-0.5,0.2-0.5,0.5v3.2c0,0.3,0.2,0.5,0.5,0.5h1.2
		c0.7,0,1.3-0.6,1.3-1.3c0-0.3-0.1-0.6-0.3-0.8C25.1,17.4,25.1,16.7,24.6,16.2z M23.7,19.1l-0.7,0v-0.7h0.7c0.2,0,0.3,0.2,0.3,0.4
		C23.9,18.9,23.8,19.1,23.7,19.1z M23.7,17.5l-0.7,0v-0.7h0.7c0.2,0,0.3,0.2,0.3,0.4C24,17.3,23.8,17.5,23.7,17.5z"
        />
      </g>
    </svg>
  );
};

export const JobsIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 19 25"
    >
      <g>
        <path
          d="M15.4,0H0.7C0.3,0,0,0.3,0,0.7v23.5C0,24.7,0.3,25,0.7,25H11h1.6h5.7c0.4,0,0.7-0.3,0.7-0.7V11.5v-1.1V3.7
		C19,1.6,17.4,0,15.4,0z M16.1,1.6c0.6,0.2,1.1,0.7,1.3,1.3h-1.3V1.6z M17.6,11.5v12H11v0H1.5V1.5h13.2v2.2c0,0.4,0.3,0.7,0.7,0.7
		h2.2v6V11.5z"
        />
        <path
          d="M9.9,20.4L9.9,20.4H3.2c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7h6.6c0.4,0,0.7-0.3,0.7-0.7
		C10.6,20.7,10.3,20.4,9.9,20.4z"
        />
        <path d="M15.8,17.7H3.2c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7h12.5c0.4,0,0.7-0.3,0.7-0.7S16.2,17.7,15.8,17.7z" />
        <path d="M15.8,14.9H3.2c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7h12.5c0.4,0,0.7-0.3,0.7-0.7S16.2,14.9,15.8,14.9z" />
        <path
          d="M4.4,13.2c1.1,0,1.9-0.9,1.9-1.9V7.8c0-0.4-0.3-0.7-0.7-0.7H4c-0.4,0-0.7,0.3-0.7,0.7S3.6,8.5,4,8.5h0.8v2.8
		c0,0.2-0.2,0.4-0.4,0.4S4,11.6,4,11.3c0-0.4-0.3-0.7-0.7-0.7s-0.7,0.3-0.7,0.7C2.5,12.4,3.4,13.2,4.4,13.2z"
        />
        <path
          d="M9.5,13.2C9.5,13.2,9.5,13.2,9.5,13.2c1.3,0,2.3-1,2.3-2.3V9.4c0-1.3-1-2.3-2.3-2.3s-2.3,1-2.3,2.3v1.6
		C7.2,12.2,8.2,13.2,9.5,13.2z M8.7,10.9V9.4c0-0.5,0.3-0.8,0.8-0.9s0.8,0.3,0.9,0.8c0,0,0,0,0,0.1v1.6c0,0.5-0.3,0.8-0.8,0.9
		S8.7,11.5,8.7,10.9C8.7,11,8.7,11,8.7,10.9z"
        />
        <path
          d="M13.4,13.2h1.2c1.1,0,1.9-0.9,1.9-1.9c0-0.4-0.1-0.8-0.4-1.2c0.7-0.8,0.5-2-0.3-2.7c-0.3-0.3-0.8-0.4-1.2-0.4v0h-1.2
		c-0.4,0-0.7,0.3-0.7,0.7v4.7C12.7,12.9,13,13.2,13.4,13.2z M14.2,8.5h0.4c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4h-0.4V8.5z
		 M14.2,10.9h0.4c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4h0h-0.4V10.9z"
        />
      </g>
    </svg>
  );
};


export const FacilityDashboardIcon = () => {
  return (
    <svg width="81" height="80" viewBox="0 0 81 80" fill="#428C7D" xmlns="http://www.w3.org/2000/svg">
      <path d="M76.1022 75.3122V21.3847H59.147V13.7722H53.0559V5.13259H42.4988V0H37.8217V5.11979H27.2647V13.7594H21.18V21.3847H4.23114V75.3122H0.168274V80H80.1651V75.3122H76.1022ZM71.4155 26.079V75.3122H59.1502V63.6775H65.5676V58.9896H59.1502V54.2986H65.5676V49.6108H59.1502V44.923H65.5676V40.232H59.1502V35.5442H65.5676V30.8564H59.1502V26.079H71.4155ZM31.9642 9.81081H48.3692V13.7722H31.9642V9.81081ZM54.4635 18.4505V75.3122H42.5116V69.8244H37.8217V75.3122H25.8699V18.4601L54.4635 18.4505ZM8.91782 26.079H21.18V30.8564H14.8842V35.5442H21.18V40.232H14.8842V44.9198H21.18V49.6076H14.8842V54.2954H21.18V58.9832H14.8842V63.6775H21.18V75.3122H8.91782V26.079Z" fill="#428C7D" />
      <path d="M32.4313 24.3446H37.4327V29.0453H32.4313V24.3446Z" />
      <path d="M42.9019 24.3446H47.9033V29.0453H42.9019V24.3446Z" />
      <path d="M32.4313 33.7234H37.4327V38.4241H32.4313V33.7234Z" />
      <path d="M42.9019 33.7234H47.9033V38.4241H42.9019V33.7234Z" />
      <path d="M32.4313 43.0991H37.4327V47.7997H32.4313V43.0991Z" />
      <path d="M42.9019 43.0991H47.9033V47.7997H42.9019V43.0991Z" />
      <path d="M32.4313 52.4747H37.4327V57.1753H32.4313V52.4747Z" />
      <path d="M42.9019 52.4747H47.9033V57.1753H42.9019V52.4747Z" />
      <path d="M32.4313 61.8535H37.4327V66.5541H32.4313V61.8535Z" />
      <path d="M42.9019 61.8535H47.9033V66.5541H42.9019V61.8535Z" />
    </svg>

  );
};

export const WorkerDashboardIcon = () => {
  return (
    <svg width="123" height="80" viewBox="0 0 123 80" fill="#B1973C" xmlns="http://www.w3.org/2000/svg">
      <path d="M61.5016 0.317459C57.8387 0.317459 54.2581 1.40364 51.2125 3.43863C48.1669 5.47362 45.7932 8.36603 44.3915 11.7501C42.9897 15.1342 42.6229 18.8579 43.3375 22.4504C44.0521 26.0429 45.816 29.3428 48.4061 31.9329C50.9961 34.523 54.2961 36.2868 57.8886 37.0014C61.4811 37.716 65.2048 37.3492 68.5889 35.9475C71.9729 34.5458 74.8654 32.172 76.9004 29.1265C78.9354 26.0809 80.0215 22.5002 80.0215 18.8374C80.0165 13.9271 78.0636 9.21945 74.5916 5.74739C71.1195 2.27532 66.4118 0.322501 61.5016 0.317459ZM61.5016 32.0622C58.8854 32.0622 56.3278 31.2864 54.1525 29.8329C51.9772 28.3794 50.2817 26.3134 49.2805 23.8963C48.2793 21.4792 48.0173 18.8195 48.5277 16.2535C49.0382 13.6875 50.298 11.3305 52.148 9.48053C53.9979 7.63056 56.355 6.37073 58.9209 5.86032C61.4869 5.34991 64.1466 5.61186 66.5637 6.61306C68.9809 7.61426 71.0468 9.30973 72.5003 11.4851C73.9539 13.6604 74.7297 16.2179 74.7297 18.8342C74.7246 22.3409 73.3293 25.7026 70.8497 28.1823C68.37 30.6619 65.0084 32.0572 61.5016 32.0622Z" fill="#B1973C" stroke="#B1973C" strokeWidth="0.2" strokeMiterlimit="10" />
      <path d="M98.535 21.4818C95.9187 21.4818 93.3612 22.2575 91.1858 23.711C89.0105 25.1646 87.3151 27.2305 86.3139 29.6476C85.3127 32.0647 85.0506 34.7245 85.561 37.2904C86.0714 39.8564 87.3314 42.2135 89.1813 44.0634C91.0313 45.9134 93.3883 47.1732 95.9543 47.6836C98.5203 48.194 101.18 47.9321 103.597 46.9309C106.014 45.9297 108.08 44.2342 109.534 42.0589C110.987 39.8835 111.763 37.326 111.763 34.7098C111.758 31.203 110.363 27.8413 107.883 25.3617C105.403 22.882 102.042 21.4868 98.535 21.4818ZM98.535 42.646C96.9653 42.646 95.431 42.1805 94.1259 41.3085C92.8208 40.4364 91.8036 39.197 91.2029 37.7468C90.6022 36.2967 90.445 34.7009 90.7512 33.1615C91.0575 31.622 91.8133 30.208 92.9232 29.0981C94.0331 27.9882 95.4472 27.2323 96.9867 26.9261C98.5261 26.6198 100.122 26.777 101.572 27.3777C103.022 27.9784 104.262 28.9955 105.134 30.3006C106.006 31.6057 106.471 33.1401 106.471 34.7098C106.471 36.8146 105.635 38.8332 104.147 40.3215C102.658 41.8098 100.64 42.646 98.535 42.646Z" fill="#B1973C" stroke="#B1973C" strokeWidth="0.2" strokeMiterlimit="10" />
      <path d="M24.8396 21.4817C22.2234 21.4817 19.6659 22.2575 17.4905 23.711C15.3152 25.1645 13.6197 27.2305 12.6185 29.6476C11.6173 32.0647 11.3553 34.7244 11.8657 37.2904C12.3762 39.8564 13.636 42.2134 15.486 44.0634C17.336 45.9133 19.693 47.1732 22.259 47.6836C24.825 48.194 27.4847 47.932 29.9018 46.9308C32.3189 45.9296 34.3848 44.2342 35.8383 42.0588C37.2919 39.8835 38.0677 37.326 38.0677 34.7097C38.0643 31.2024 36.6696 27.8398 34.1896 25.3598C31.7096 22.8798 28.3469 21.4851 24.8396 21.4817ZM24.8396 42.6459C23.27 42.6459 21.7356 42.1805 20.4305 41.3084C19.1254 40.4364 18.1082 39.1969 17.5075 37.7468C16.9069 36.2966 16.7497 34.7009 17.0559 33.1614C17.3621 31.6219 18.118 30.2079 19.2279 29.098C20.3378 27.9881 21.7519 27.2322 23.2914 26.926C24.8308 26.6198 26.4265 26.777 27.8767 27.3776C29.3268 27.9783 30.5663 28.9955 31.4383 30.3006C32.3104 31.6057 32.7758 33.1401 32.7758 34.7097C32.7758 36.8145 31.9397 38.8331 30.4514 40.3214C28.963 41.8098 26.9444 42.6459 24.8396 42.6459Z" fill="#B1973C" stroke="#B1973C" strokeWidth="0.2" strokeMiterlimit="10" />
      <path d="M61.5015 42.646C52.3832 42.656 43.6413 46.2828 37.1937 52.7304C30.746 59.178 27.1193 67.92 27.1093 77.0383C27.1093 77.74 27.388 78.413 27.8842 78.9092C28.3804 79.4054 29.0534 79.6842 29.7552 79.6842C30.4569 79.6842 31.1299 79.4054 31.6261 78.9092C32.1223 78.413 32.4011 77.74 32.4011 77.0383C32.4011 69.3204 35.467 61.9185 40.9244 56.4612C46.3818 51.0038 53.7836 47.9378 61.5015 47.9378C69.2195 47.9378 76.6213 51.0038 82.0787 56.4612C87.536 61.9185 90.602 69.3204 90.602 77.0383C90.602 77.74 90.8807 78.413 91.3769 78.9092C91.8731 79.4054 92.5462 79.6842 93.2479 79.6842C93.9496 79.6842 94.6226 79.4054 95.1189 78.9092C95.6151 78.413 95.8938 77.74 95.8938 77.0383C95.8837 67.92 92.257 59.178 85.8094 52.7304C79.3618 46.2828 70.6198 42.656 61.5015 42.646Z" fill="#B1973C" stroke="#B1973C" strokeWidth="0.2" strokeMiterlimit="10" />
      <path d="M98.5415 53.2264C94.1937 53.2249 89.9285 54.4139 86.2086 56.6644C85.6348 57.0407 85.2294 57.6251 85.078 58.2944C84.9267 58.9637 85.0411 59.6656 85.3972 60.2522C85.7532 60.8388 86.3232 61.2642 86.9868 61.4388C87.6504 61.6134 88.3559 61.5234 88.9545 61.188C91.7638 59.4895 94.9741 58.5681 98.2566 58.5182C101.539 58.4682 104.776 59.2916 107.636 60.9039C110.495 62.5162 112.875 64.8596 114.531 67.694C116.187 70.5285 117.061 73.7522 117.061 77.035C117.061 77.7368 117.34 78.4098 117.836 78.906C118.333 79.4022 119.006 79.6809 119.707 79.6809C120.409 79.6809 121.082 79.4022 121.578 78.906C122.074 78.4098 122.353 77.7368 122.353 77.035C122.345 70.7226 119.833 64.6713 115.369 60.208C110.906 55.7448 104.854 53.234 98.5415 53.2264Z" fill="#B1973C" stroke="#B1973C" strokeWidth="0.2" strokeMiterlimit="10" />
      <path d="M36.7914 56.6612C33.1799 54.4749 29.052 53.2883 24.8308 53.2228C20.6096 53.1574 16.4468 54.2156 12.7693 56.2889C9.09174 58.3622 6.03161 61.3761 3.90254 65.0216C1.77348 68.6672 0.652051 72.8133 0.653199 77.035C0.653199 77.7367 0.931966 78.4098 1.42817 78.906C1.92438 79.4022 2.59738 79.6809 3.29913 79.6809C4.00087 79.6809 4.67387 79.4022 5.17008 78.906C5.66629 78.4098 5.94505 77.7367 5.94505 77.035C5.94632 73.7529 6.81947 70.5301 8.47516 67.6963C10.1309 64.8625 12.5097 62.5193 15.3682 60.9067C18.2267 59.294 21.4623 58.4696 24.744 58.518C28.0258 58.5663 31.2357 59.4855 34.0455 61.1817C34.6454 61.5458 35.3653 61.6567 36.047 61.4901C36.7286 61.3234 37.3162 60.8927 37.6803 60.2928C38.0444 59.693 38.1553 58.973 37.9887 58.2914C37.822 57.6097 37.3913 57.0221 36.7914 56.658V56.6612Z" fill="#B1973C" stroke="#B1973C" strokeWidth="0.2" strokeMiterlimit="10" />
    </svg>
  );
};


export const JobDashboardIcon = () => {
  return (
    <svg width="81" height="80" viewBox="0 0 81 80" fill="#D87179" xmlns="http://www.w3.org/2000/svg">
      <path d="M43.6202 43.2916C45.1437 41.7659 45.1451 39.2971 43.6231 37.7773C42.1012 36.2575 39.6324 36.2623 38.1088 37.7879C36.5853 39.3136 36.584 41.7824 38.1059 43.3022C39.6278 44.822 42.0967 44.8173 43.6202 43.2916Z" />
      <path d="M62.0319 80H19.6255C14.6647 79.994 9.90873 78.021 6.40063 74.5135C2.89252 71.006 0.91864 66.2504 0.911865 61.2896V38.832C0.917793 33.8707 2.8913 29.1142 6.3995 25.606C9.9077 22.0978 14.6641 20.1243 19.6255 20.1184H62.0319C66.9932 20.1243 71.7496 22.0978 75.2578 25.606C78.766 29.1142 80.7395 33.8707 80.7455 38.832V61.2896C80.7387 66.2504 78.7648 71.006 75.2567 74.5135C71.7486 78.021 66.9927 79.994 62.0319 80ZM19.6255 26.3552C16.3156 26.3552 13.1412 27.67 10.8008 30.0105C8.46032 32.3509 7.14547 35.5253 7.14547 38.8352V61.2928C7.14547 64.6027 8.46032 67.777 10.8008 70.1175C13.1412 72.4579 16.3156 73.7728 19.6255 73.7728H62.0319C65.3418 73.7728 68.5161 72.4579 70.8566 70.1175C73.197 67.777 74.5119 64.6027 74.5119 61.2928V38.8352C74.5119 35.5253 73.197 32.3509 70.8566 30.0105C68.5161 27.67 65.3418 26.3552 62.0319 26.3552H19.6255Z" />
      <path d="M48.4767 58.9504H33.1935C28.6868 58.9454 24.3661 57.1528 21.1794 53.9661C17.9927 50.7794 16.2002 46.4587 16.1951 41.952C16.1817 41.5341 16.2524 41.1178 16.4031 40.7277C16.5538 40.3377 16.7814 39.9819 17.0723 39.6815C17.3631 39.3812 17.7115 39.1423 18.0965 38.9792C18.4815 38.8161 18.8954 38.7321 19.3135 38.7321C19.7316 38.7321 20.1455 38.8161 20.5305 38.9792C20.9155 39.1423 21.2638 39.3812 21.5547 39.6815C21.8456 39.9819 22.0732 40.3377 22.2238 40.7277C22.3745 41.1178 22.4453 41.5341 22.4319 41.952C22.4344 44.8054 23.569 47.5412 25.5867 49.5588C27.6043 51.5765 30.3401 52.7111 33.1935 52.7136H48.4767C51.33 52.7111 54.0658 51.5765 56.0835 49.5588C58.1011 47.5412 59.2357 44.8054 59.2383 41.952C59.2249 41.5341 59.2956 41.1178 59.4463 40.7277C59.597 40.3377 59.8246 39.9819 60.1155 39.6815C60.4064 39.3812 60.7547 39.1423 61.1397 38.9792C61.5247 38.8161 61.9385 38.7321 62.3567 38.7321C62.7748 38.7321 63.1887 38.8161 63.5737 38.9792C63.9587 39.1423 64.307 39.3812 64.5979 39.6815C64.8888 39.9819 65.1163 40.3377 65.267 40.7277C65.4177 41.1178 65.4885 41.5341 65.4751 41.952C65.47 46.4587 63.6775 50.7794 60.4908 53.9661C57.304 57.1528 52.9834 58.9454 48.4767 58.9504Z" />
      <path d="M52.5311 13.8784C51.7036 13.8784 50.91 13.5497 50.3249 12.9646C49.7398 12.3795 49.4111 11.5859 49.4111 10.7584C49.4094 9.56138 48.9338 8.41372 48.0883 7.5664C47.2427 6.71907 46.0961 6.24103 44.8991 6.2368H36.7903C35.5916 6.23849 34.4425 6.71542 33.5949 7.56302C32.7473 8.41061 32.2704 9.55972 32.2687 10.7584C32.2821 11.1763 32.2113 11.5927 32.0606 11.9827C31.9099 12.3727 31.6824 12.7285 31.3915 13.0289C31.1006 13.3292 30.7523 13.5681 30.3673 13.7312C29.9823 13.8943 29.5684 13.9783 29.1503 13.9783C28.7321 13.9783 28.3183 13.8943 27.9333 13.7312C27.5483 13.5681 27.2 13.3292 26.9091 13.0289C26.6182 12.7285 26.3906 12.3727 26.2399 11.9827C26.0892 11.5927 26.0185 11.1763 26.0319 10.7584C26.0353 7.90779 27.1685 5.17477 29.1833 3.15819C31.1981 1.14161 33.9301 0.00592617 36.7807 0L44.8991 0C47.7524 0.00254198 50.4883 1.13717 52.5059 3.15481C54.5235 5.17245 55.6581 7.90823 55.6607 10.7616C55.6603 11.1719 55.5789 11.578 55.4213 11.9568C55.2637 12.3356 55.033 12.6796 54.7423 12.9691C54.4516 13.2586 54.1067 13.4879 53.7273 13.644C53.3478 13.8 52.9414 13.8797 52.5311 13.8784Z" />
    </svg>
  );
};


